(() => {
  if (window.__sbCartSystemInitialized) return;
  window.__sbCartSystemInitialized = true;

  const EVENTS = {
    cartChanged: 'sb:cart:changed',
    drawerState: 'sb:cart-drawer:state-change',
    mutationState: 'sb:cart-mutation:state-change',
  };

  const CART_ROW_REMOVE_DELAY = 170;
  const CART_ROW_REMOVE_ANIMATION_DURATION = 300;
  const CART_ROW_REMOVE_FADE_DURATION = 180;
  const CART_DRAWER_OPEN_SETTLE_DURATION = 520;
  const CART_FREE_SHIPPING_PROGRESS_DURATION = 420;
  const CART_FREE_SHIPPING_CELEBRATION_DURATION = 750;
  const BUTTON_SUCCESS_RESET_DELAY = 1800;
  const NATIVE_BUTTON_SUCCESS_RESET_DELAY = 1060;
  const ATC_BURST_SVG = `
    <svg aria-hidden="true" class="sb-atc-burst-svg" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g class="check">
        <circle class="ring" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></circle>
        <path class="tick" d="M9 12.75L11.25 15L15 9.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
      </g>
      <g class="burst">
        <g style="--index: 0;"><line class="line" stroke-linecap="round" pathLength="1" x1="12" y1="8.5" x2="12" y2="15.5" stroke="currentColor"></line></g>
        <g style="--index: 1;"><line class="line" stroke-linecap="round" pathLength="1" x1="12" y1="8.5" x2="12" y2="15.5" stroke="currentColor"></line></g>
        <g style="--index: 2;"><line class="line" stroke-linecap="round" pathLength="1" x1="12" y1="8.5" x2="12" y2="15.5" stroke="currentColor"></line></g>
        <g style="--index: 3;"><line class="line" stroke-linecap="round" pathLength="1" x1="12" y1="8.5" x2="12" y2="15.5" stroke="currentColor"></line></g>
        <g style="--index: 4;"><line class="line" stroke-linecap="round" pathLength="1" x1="12" y1="8.5" x2="12" y2="15.5" stroke="currentColor"></line></g>
        <g style="--index: 5;"><line class="line" stroke-linecap="round" pathLength="1" x1="12" y1="8.5" x2="12" y2="15.5" stroke="currentColor"></line></g>
        <g style="--index: 6;"><line class="line" stroke-linecap="round" pathLength="1" x1="12" y1="8.5" x2="12" y2="15.5" stroke="currentColor"></line></g>
        <g style="--index: 7;"><line class="line" stroke-linecap="round" pathLength="1" x1="12" y1="8.5" x2="12" y2="15.5" stroke="currentColor"></line></g>
      </g>
    </svg>
  `;

  const ensureAtcAnimationStyles = (() => {
    let didInject = false;

    return () => {
      if (didInject || typeof document === 'undefined') return;
      if (document.querySelector('style[data-sb-atc-animation-styles]')) {
        didInject = true;
        return;
      }

      const style = document.createElement('style');
      style.setAttribute('data-sb-atc-animation-styles', 'true');
      style.textContent = `
        fly-to-cart {
          --offset-y: 10px;
          --x-timing: cubic-bezier(0.7, -5, 0.98, 0.5);
          --y-timing: cubic-bezier(0.15, 0.57, 0.9, 1.05);
          --scale-timing: cubic-bezier(0.85, 0.05, 0.96, 1);
          position: fixed;
          width: var(--width, 40px);
          height: var(--height, 40px);
          left: 0;
          top: 0;
          z-index: 2147483647;
          pointer-events: none;
          border-radius: 999px;
          overflow: hidden;
          object-fit: cover;
          background-size: cover;
          background-position: center;
          opacity: 0;
          background-color: var(--sb-color-neutral-700);
          translate: var(--start-x, 0) var(--start-y, 0);
          transform: translate(-50%, -50%);
          animation-name: sb-fly-travel-x, sb-fly-travel-y, sb-fly-travel-scale;
          animation-timing-function: var(--x-timing), var(--y-timing), var(--scale-timing);
          animation-duration: 0.6s;
          animation-fill-mode: both;
          animation-composition: accumulate;
          will-change: transform, translate, opacity;
        }

        fly-to-cart.fly-to-cart--quick {
          --x-timing: cubic-bezier(0, -0.1, 1, 0.32);
          --y-timing: cubic-bezier(0, 0.92, 0.92, 1.04);
          --scale-timing: cubic-bezier(0.86, 0.08, 0.98, 0.98);
        }

        fly-to-cart.fly-to-cart--sticky {
          --x-timing: cubic-bezier(0.32, 0, 0.2, 1);
          --y-timing: cubic-bezier(0.22, 1, 0.36, 1);
          --scale-timing: cubic-bezier(0.86, 0.08, 0.98, 0.98);
          animation-duration: 0.76s;
        }

        @keyframes sb-fly-travel-x {
          to {
            translate: var(--travel-x, 0) 0;
          }
        }

        @keyframes sb-fly-travel-y {
          to {
            translate: 0 var(--travel-y, 0);
          }
        }

        @keyframes sb-fly-travel-scale {
          0% {
            opacity: var(--start-opacity, 1);
          }

          5% {
            opacity: 1;
          }

          100% {
            border-radius: 999px;
            opacity: 1;
            transform: translate(-50%, calc(-50% + var(--offset-y))) scale(0.25);
          }
        }

        .sb-atc-burst {
          position: absolute;
          inset: 50% auto auto 50%;
          width: 22px;
          height: 22px;
          translate: -50% -50%;
          color: var(--sb-color-always-white);
          pointer-events: none;
          opacity: 0;
          overflow: visible;
          z-index: 6;
        }

        .sb-product-thumbnail__add-to-cart .sb-atc-burst {
          color: var(--sb-color-primary-500);
        }

        .sb-atc-button:has(> .sb-atc-burst) > :not(.sb-atc-burst) {
          clip-path: circle(100% at 50% 50%);
          filter: blur(0);
          opacity: 1;
          translate: 0 0;
        }

        .sb-atc-button[data-added='true']:has(> .sb-atc-burst) > :not(.sb-atc-burst) {
          clip-path: circle(0% at 50% 50%);
          filter: blur(2px);
          opacity: 0;
          translate: 0 4px;
        }

        .sb-atc-burst .burst {
          rotate: 20deg;
          transform-box: fill-box;
          transform-origin: center;
        }

        .sb-atc-burst .check {
          opacity: 0.2;
          scale: 0.8;
          filter: blur(2px);
          transform: translateZ(0);
          transform-box: fill-box;
          transform-origin: center;
        }

        .sb-atc-burst .line,
        .sb-atc-burst .ring,
        .sb-atc-burst .tick {
          transform-box: fill-box;
          transform-origin: center;
        }

        .sb-atc-burst .line {
          stroke-dasharray: 1.5 1.5;
          stroke-dashoffset: -1.5;
          translate: 0 -180%;
        }

        .sb-atc-burst g {
          transform-origin: center;
          rotate: calc(var(--index) * (360 / 8) * 1deg);
        }

        .sb-atc-button[data-added='true'] .sb-atc-burst {
          opacity: 1;
        }

        .sb-atc-button[data-added='true'] .sb-atc-burst .check {
          opacity: 1;
          scale: 1;
          filter: blur(0);
        }

        .sb-atc-button[data-added='true'] .sb-atc-burst .tick {
          scale: 1.75;
        }

        .sb-atc-button[data-added='true'] .sb-atc-burst .ring {
          opacity: 0;
          scale: 1;
        }

        .sb-atc-button[data-added='true'] .sb-atc-burst .line {
          stroke-dashoffset: 1.5;
        }

        @media (prefers-reduced-motion: no-preference) {
          .sb-atc-button:has(> .sb-atc-burst) > :not(.sb-atc-burst) {
            transition: clip-path 156ms ease-out, opacity 260ms ease-out, filter 156ms ease-out, translate 260ms ease-out;
          }

          .sb-atc-burst .check {
            transition-property: opacity, scale, filter;
            transition-duration: 0.2s;
            transition-delay: 0.065s;
            transition-timing-function: ease-out;
          }

          .sb-atc-burst .tick {
            transition-property: scale;
            transition-duration: 0.1s;
            transition-delay: 0.725s;
            transition-timing-function: ease-out;
          }

          .sb-atc-burst .ring {
            transition-property: opacity, scale;
            transition-duration: 0.2s;
            transition-delay: 0.665s;
            transition-timing-function: ease-out;
          }

          .sb-atc-burst .line {
            transition-property: stroke-dashoffset;
            transition-duration: 0.32s;
            transition-delay: 0.665s;
            transition-timing-function: cubic-bezier(0.22, 1, 0.36, 1);
          }

          .sb-atc-button.sb-atc-resetting,
          .sb-atc-button.sb-atc-resetting *,
          .sb-atc-button.sb-atc-resetting *::before,
          .sb-atc-button.sb-atc-resetting *::after {
            transition: none !important;
          }
        }
      `;

      document.head.appendChild(style);
      didInject = true;
    };
  })();

  class FlyToCartElement extends HTMLElement {
    connectedCallback() {
      const source =
        (this.sourceElement && this.sourceElement instanceof Element && this.sourceElement) ||
        (this.source && this.source instanceof Element && this.source) ||
        null;
      const destination =
        (this.destinationElement && this.destinationElement instanceof Element && this.destinationElement) ||
        (this.destination && this.destination instanceof Element && this.destination) ||
        null;

      if (!source || !destination) {
        this.remove();
        return;
      }

      const sourceRect = source.getBoundingClientRect();
      const destinationRect = destination.getBoundingClientRect();

      if (!sourceRect.width || !sourceRect.height || !destinationRect.width || !destinationRect.height) {
        this.remove();
        return;
      }

      const getClampedCenter = (rect, minMargin = 16) => {
        const viewportWidth = document.documentElement.clientWidth || window.innerWidth || 0;
        const viewportHeight = document.documentElement.clientHeight || window.innerHeight || 0;
        const centerX = rect.left + rect.width / 2;
        const centerY = rect.top + rect.height / 2;

        if (!viewportWidth || !viewportHeight) {
          return { x: centerX, y: centerY };
        }

        const marginX = Math.min(Math.max(rect.width / 2, minMargin), viewportWidth / 2);
        const marginY = Math.min(Math.max(rect.height / 2, minMargin), viewportHeight / 2);
        const minX = marginX;
        const maxX = Math.max(minX, viewportWidth - marginX);
        const minY = marginY;
        const maxY = Math.max(minY, viewportHeight - marginY);

        return {
          x: Math.min(Math.max(centerX, minX), maxX),
          y: Math.min(Math.max(centerY, minY), maxY),
        };
      };

      const start = getClampedCenter(sourceRect);
      const end = getClampedCenter(destinationRect);

      this.style.setProperty('--start-x', `${start.x}px`);
      this.style.setProperty('--start-y', `${start.y}px`);
      this.style.setProperty('--travel-x', `${end.x - start.x}px`);
      this.style.setProperty('--travel-y', `${end.y - start.y}px`);
      if (`${this.dataset.useSourceSize || ''}`.toLowerCase() === 'true') {
        this.style.setProperty('--width', `${sourceRect.width}px`);
        this.style.setProperty('--height', `${sourceRect.height}px`);
      }

      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => {
          const animations = this.getAnimations();
          if (!animations.length) {
            window.setTimeout(() => this.remove(), 640);
            return;
          }
          Promise.allSettled(animations.map((animation) => animation.finished)).finally(() => {
            this.remove();
          });
        });
      });
    }
  }

  if (!customElements.get('fly-to-cart')) {
    customElements.define('fly-to-cart', FlyToCartElement);
  }
  const prefersReducedMotion = () =>
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const shopRoot = (() => {
    const root =
      window.Shopify && window.Shopify.routes && typeof window.Shopify.routes.root === 'string'
        ? window.Shopify.routes.root
        : '/';
    return root.endsWith('/') ? root : `${root}/`;
  })();

  const cartUrl = (path) => `${shopRoot}${path}`;
  const normalizePathname = (pathname) => {
    const value = `${pathname || '/'}`;
    const trimmed = value.replace(/\/+$/, '');
    return trimmed === '' ? '/' : trimmed;
  };
  const isOnCartPage = (() => {
    try {
      const cartPathname = normalizePathname(new URL(cartUrl('cart'), window.location.origin).pathname);
      const currentPathname = normalizePathname(window.location.pathname);
      return currentPathname === cartPathname;
    } catch (_) {
      return false;
    }
  })();

  const headerCartCountNode = document.querySelector('[data-header-cart-count]');
  let previousCartCount = (() => {
    if (!headerCartCountNode) return 0;
    const raw = `${headerCartCountNode.textContent || '0'}`.trim();
    if (raw.endsWith('+')) return 100;
    const parsed = Number.parseInt(raw, 10);
    return Number.isFinite(parsed) ? Math.max(0, parsed) : 0;
  })();

  const clampCount = (count) => {
    const parsed = Number.parseInt(`${count}`, 10);
    return Number.isFinite(parsed) ? Math.max(0, parsed) : 0;
  };

  const triggerBadgeBump = () => {
    if (!headerCartCountNode || headerCartCountNode.hidden) return;
    headerCartCountNode.classList.remove('is-bump');
    void headerCartCountNode.offsetWidth;
    headerCartCountNode.classList.add('is-bump');
  };

  const setHeaderCartCount = (count, { animate = true } = {}) => {
    if (!headerCartCountNode) return;
    const normalized = clampCount(count);
    const wasHidden = headerCartCountNode.hidden;

    if (normalized <= 0) {
      headerCartCountNode.textContent = '';
      headerCartCountNode.hidden = true;
      headerCartCountNode.classList.remove('is-double-digit', 'is-bump');
      previousCartCount = 0;
      return;
    }

    const displayCount = normalized > 99 ? '99+' : `${normalized}`;
    headerCartCountNode.hidden = false;
    headerCartCountNode.textContent = displayCount;
    headerCartCountNode.classList.toggle('is-double-digit', displayCount.length > 1);

    const shouldAnimate =
      animate && normalized > 0 && (wasHidden || normalized !== previousCartCount);
    previousCartCount = normalized;

    if (shouldAnimate) triggerBadgeBump();
  };

  setHeaderCartCount(previousCartCount, { animate: false });

  if (headerCartCountNode) {
    headerCartCountNode.addEventListener('animationend', () => {
      headerCartCountNode.classList.remove('is-bump');
    });
  }

  const formatMoney = (cents, currency = '') => {
    const amount = Number.isFinite(Number(cents)) ? Math.round(Number(cents)) : 0;
    const currencyCode = `${currency || ''}`.trim().toUpperCase();

    try {
      const storefrontPricing = window.SBStorefrontPricing;
      if (storefrontPricing && typeof storefrontPricing.formatMoney === 'function') {
        const formatted = storefrontPricing.formatMoney(amount, currencyCode, { context: 'cart' });
        if (`${formatted || ''}`.trim() !== '') return formatted;
      }
    } catch (_) {
      // no-op
    }

    return `${amount / 100}`;
  };


  /* Keyed DOM morph for the cart line list (Horizon's morph idea, purpose-
     built): a quantity update patches the existing rows in place instead of
     rebuilding the list, so node identity - and with it keyboard focus,
     hover state, and in-flight transitions - survives the re-render. Rows
     are keyed by data-cart-item-key; inside a matched row the trees are
     positionally synced, which is reliable because every row is stamped
     from the same template. */
  const syncMorphAttributes = (oldElement, newElement) => {
    // A preceding queued mutation can re-render this row while its own removal
    // is still running. Keep the animation-owned classes and measured height
    // without preventing the rest of the keyed row from updating.
    const preservedRemovalClasses =
      oldElement.classList.contains('sb-cart-line')
        ? ['is-removing', 'is-removal-complete'].filter((className) =>
            oldElement.classList.contains(className)
          )
        : [];
    const preservedRowStyle = preservedRemovalClasses.length
      ? oldElement.getAttribute('style') || ''
      : '';

    for (const attribute of Array.from(oldElement.attributes)) {
      if (
        preservedRowStyle &&
        attribute.name === 'style' &&
        !newElement.hasAttribute(attribute.name)
      ) {
        continue;
      }
      if (!newElement.hasAttribute(attribute.name)) oldElement.removeAttribute(attribute.name);
    }
    for (const attribute of Array.from(newElement.attributes)) {
      let nextValue = attribute.value;
      if (attribute.name === 'class' && preservedRemovalClasses.length) {
        const nextClasses = new Set(Array.from(newElement.classList));
        preservedRemovalClasses.forEach((className) => nextClasses.add(className));
        nextValue = Array.from(nextClasses).join(' ');
      }
      if (oldElement.getAttribute(attribute.name) !== nextValue) {
        oldElement.setAttribute(attribute.name, nextValue);
      }
    }
    if (preservedRowStyle && !oldElement.hasAttribute('style')) {
      oldElement.setAttribute('style', preservedRowStyle);
    }
    if (oldElement instanceof HTMLInputElement && newElement instanceof HTMLInputElement) {
      // never clobber a value the visitor is mid-typing
      if (document.activeElement !== oldElement && oldElement.value !== newElement.value) {
        oldElement.value = newElement.value;
      }
    }
    if (
      (oldElement instanceof HTMLButtonElement || oldElement instanceof HTMLInputElement)
      && (newElement instanceof HTMLButtonElement || newElement instanceof HTMLInputElement)
    ) {
      oldElement.disabled = newElement.disabled;
    }
  };

  const morphNode = (oldNode, newNode) => {
    const tagMismatch = oldNode instanceof Element && newNode instanceof Element
      && oldNode.tagName !== newNode.tagName;
    if (oldNode.nodeType !== newNode.nodeType || tagMismatch) {
      oldNode.replaceWith(newNode);
      return;
    }
    if (oldNode.nodeType === Node.TEXT_NODE) {
      if (oldNode.nodeValue !== newNode.nodeValue) oldNode.nodeValue = newNode.nodeValue;
      return;
    }
    if (!(oldNode instanceof Element) || !(newNode instanceof Element)) return;
    syncMorphAttributes(oldNode, newNode);
    const oldChildren = Array.from(oldNode.childNodes);
    const newChildren = Array.from(newNode.childNodes);
    const shared = Math.min(oldChildren.length, newChildren.length);
    for (let index = 0; index < shared; index += 1) morphNode(oldChildren[index], newChildren[index]);
    for (let index = oldChildren.length - 1; index >= shared; index -= 1) oldChildren[index].remove();
    for (let index = shared; index < newChildren.length; index += 1) oldNode.appendChild(newChildren[index]);
  };

  const MORPH_FOCUS_CONTROLS = ['data-cart-qty-plus', 'data-cart-qty-minus', 'data-cart-qty-input', 'data-cart-remove'];
  let pendingMorphFocus = null;

  const cartRowItemKey = (row) => row.getAttribute('data-cart-item-key') || '';
  const cartRowLine = (row) => row.getAttribute('data-cart-line') || '';

  // Called at the end of every morph AND when a line's pending state clears:
  // the disabled interlude drops focus to body, and only once the control is
  // interactive again can the visitor's place be handed back.
  const restoreMorphFocus = (listNode) => {
    if (!pendingMorphFocus || !(listNode instanceof HTMLElement)) return;
    const focusIsFree = document.activeElement === document.body || listNode.contains(document.activeElement);
    if (!focusIsFree) {
      pendingMorphFocus = null;
      return;
    }
    const rows = Array.from(listNode.children);
    const row = (pendingMorphFocus.key && rows.find((child) => cartRowItemKey(child) === pendingMorphFocus.key))
      || rows.find((child) => cartRowLine(child) === pendingMorphFocus.line);
    if (!row) {
      pendingMorphFocus = null;
      return;
    }
    const control = row.querySelector(`[${pendingMorphFocus.control}]`);
    if (control instanceof HTMLElement && !control.disabled) {
      control.focus({ preventScroll: true });
      pendingMorphFocus = null;
    }
  };

  // Rows whose removal the server has already confirmed, mapped to a
  // finalizer that clears the removal's backstop timer and detaches the row.
  // Normally the collapse animation finishes and the row removes itself; if
  // the animation stalls (frame-starved headless or low-end renderers), the
  // row would otherwise outlive the item it shows - preserved by the morph,
  // invisible to line lookups, still matching variant-scoped selectors, and
  // hidden only when its stale backstop timer fires - so every render purges
  // confirmed rows before touching the list.
  const confirmedRemovalFinalizers = new WeakMap();

  const purgeConfirmedRemovalRows = (listNode) => {
    if (!(listNode instanceof HTMLElement)) return;
    for (const row of Array.from(listNode.children)) {
      const finalizeRemoval = confirmedRemovalFinalizers.get(row);
      if (!finalizeRemoval) continue;
      confirmedRemovalFinalizers.delete(row);
      finalizeRemoval();
      if (row.isConnected) row.remove();
    }
  };

  const morphCartLineList = (listNode, fragment) => {
    // Remember which control the visitor is on: the pending state disables it
    // (dropping focus to body), so the intent must survive across the
    // optimistic and the server-confirm renders until the control is
    // interactive again.
    const active = document.activeElement;
    const itemKeyOf = cartRowItemKey;
    const lineOf = cartRowLine;
    if (active instanceof HTMLElement && listNode.contains(active)) {
      const row = active.closest('[data-cart-line]');
      const control = MORPH_FOCUS_CONTROLS.find((attribute) => active.hasAttribute(attribute));
      if (row && control) pendingMorphFocus = { key: itemKeyOf(row), line: lineOf(row), control };
    }

    const oldRows = Array.from(listNode.children);
    const claimed = new Set();
    const variantOf = (row) => row.getAttribute('data-cart-variant-id') || '';
    // A row mid-removal stays in place until its collapse animation finishes:
    // yanking it when the server confirm lands cuts the motion short and the
    // remaining height disappears in one visible jump. It is also invisible
    // to matching so a renumbered line can never resurrect it. (This never
    // preserves a row past its usefulness: renderItems purges rows with a
    // confirmed removal before the morph runs.)
    const isMidRemoval = (row) =>
      row instanceof HTMLElement
      && row.classList.contains('is-removing')
      && !row.classList.contains('is-removal-complete');
    // Rows touched by a removal - mid-animation OR completed - must never be
    // recycled as the node for a live item: a completed row still carries its
    // is-removal-complete class and finished fill-forwards animations
    // (height 0, opacity 0), so a live item morphed onto it vanishes in a
    // single frame.
    const isRemovalTouched = (row) =>
      row instanceof HTMLElement
      && (row.classList.contains('is-removing') || row.classList.contains('is-removal-complete'));
    const matchOldRow = (newRow) => {
      const key = itemKeyOf(newRow);
      let match = key
        ? oldRows.find((row) => !claimed.has(row) && !isRemovalTouched(row) && itemKeyOf(row) === key)
        : null;
      if (!match) {
        // Shopify's line key hash is NOT stable across renders when discount
        // allocations recompute, so fall back to position + variant identity
        const line = lineOf(newRow);
        const variantId = variantOf(newRow);
        match = line
          ? oldRows.find((row) => {
              if (claimed.has(row) || isRemovalTouched(row) || lineOf(row) !== line) return false;
              const oldVariant = variantOf(row);
              return !oldVariant || !variantId || oldVariant === variantId;
            })
          : null;
      }
      if (match) claimed.add(match);
      return match || null;
    };

    const orderedRows = Array.from(fragment.children).map((newRow) => {
      const oldRow = matchOldRow(newRow);
      if (oldRow) {
        morphNode(oldRow, newRow);
        return oldRow;
      }
      return newRow;
    });
    oldRows.forEach((row) => {
      if (!claimed.has(row) && !isMidRemoval(row)) row.remove();
    });
    let insertionCursor = 0;
    orderedRows.forEach((row) => {
      while (
        listNode.children[insertionCursor]
        && listNode.children[insertionCursor] !== row
        && isMidRemoval(listNode.children[insertionCursor])
      ) {
        insertionCursor += 1;
      }
      if (listNode.children[insertionCursor] !== row) {
        listNode.insertBefore(row, listNode.children[insertionCursor] || null);
      }
      insertionCursor += 1;
    });
    while (listNode.children[insertionCursor]) {
      const trailing = listNode.children[insertionCursor];
      if (isMidRemoval(trailing)) insertionCursor += 1;
      else trailing.remove();
    }

    restoreMorphFocus(listNode);
  };

  const boundCartHoverImages = new WeakSet();

  const prepareCartHoverImages = (scope) => {
    if (!(scope instanceof Element)) return;

    scope.querySelectorAll('.sb-cart-line__image--hover').forEach((image) => {
      if (!(image instanceof HTMLImageElement)) return;

      const media = image.closest('.sb-cart-line__media--has-hover');
      if (!(media instanceof HTMLElement)) return;

      const clearReadyState = () => media.classList.remove('is-hover-image-ready');
      const markReady = async () => {
        const source = image.currentSrc || image.src;
        if (image.hasAttribute('data-sb-cart-deferred-image') || !image.complete || image.naturalWidth <= 0) {
          clearReadyState();
          return;
        }

        try {
          await image.decode();
        } catch (_error) {
          // A loaded image remains safe to display when decode() is unavailable or rejects.
        }

        if (image.isConnected && !image.hasAttribute('data-sb-cart-deferred-image') && source === (image.currentSrc || image.src) && image.naturalWidth > 0) {
          media.classList.add('is-hover-image-ready');
        }
      };

      if (!boundCartHoverImages.has(image)) {
        boundCartHoverImages.add(image);
        image.addEventListener('load', markReady);
        image.addEventListener('error', clearReadyState);
      }
      // Recompute readiness on EVERY prepare pass, not only on first bind:
      // morph re-renders resync the media element's class attribute from
      // fresh markup, wiping is-hover-image-ready - and a cached image fires
      // no further load events, so without this every row rendered before
      // the latest mutation permanently loses its hover.
      void markReady();
    });
  };

  const escapeHtml = (value) => {
    const text = `${value == null ? '' : value}`;
    return text
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  };

  const normalizeStringArray = (value) => {
    if (Array.isArray(value)) {
      return value
        .map((entry) => `${entry}`.trim())
        .filter(Boolean);
    }

    if (typeof value === 'string') {
      return value
        .split(',')
        .map((entry) => entry.trim())
        .filter(Boolean);
    }

    return [];
  };

  const getAppliedDiscountCodes = (cart) => {
    const codes = [];

    if (cart && Array.isArray(cart.cart_level_discount_applications)) {
      cart.cart_level_discount_applications.forEach((discount) => {
        const type = `${discount && discount.type ? discount.type : ''}`.toLowerCase();
        const title = `${discount && discount.title ? discount.title : ''}`.trim();
        if (title && type === 'discount_code') {
          codes.push(title);
        }
      });
    }

    if (cart && Array.isArray(cart.items)) {
      cart.items.forEach((item) => {
        if (!item || !Array.isArray(item.line_level_discount_allocations)) return;
        item.line_level_discount_allocations.forEach((allocation) => {
          const application = allocation && allocation.discount_application ? allocation.discount_application : null;
          const type = `${application && application.type ? application.type : ''}`.toLowerCase();
          const title = `${application && application.title ? application.title : ''}`.trim();
          if (title && type === 'discount_code') {
            codes.push(title);
          }
        });
      });
    }

    return [...new Set(codes)];
  };

  const cartHasAcceptedDiscountCode = (cart, code) => {
    const normalizedCode = `${code || ''}`.trim().toLowerCase();
    if (!normalizedCode) return false;

    if (getAppliedDiscountCodes(cart).some((entry) => entry.toLowerCase() === normalizedCode)) {
      return true;
    }

    const discountCodes = Array.isArray(cart && cart.discount_codes) ? cart.discount_codes : [];
    const attemptedEntry = discountCodes.find((entry) => (
      entry && `${entry.code || ''}`.trim().toLowerCase() === normalizedCode
    ));
    if (!attemptedEntry) return false;

    // Shopify persists a valid code but reports applicable:false while the cart
    // is empty because there are no lines to evaluate. Once a line exists, the
    // applicability flag is authoritative.
    return attemptedEntry.applicable === true || Number(cart && cart.item_count) === 0;
  };

  const getAppliedCodeDiscountPercentage = (cart) => {
    const percentages = [];
    const collect = (application) => {
      const type = `${application && application.type ? application.type : ''}`.trim().toLowerCase();
      const valueType = `${application && application.value_type ? application.value_type : ''}`.trim().toLowerCase();
      const value = Number(application && application.value);
      if (type === 'discount_code' && valueType === 'percentage' && Number.isFinite(value) && value > 0) {
        percentages.push(value);
      }
    };

    const cartLevelApplications = Array.isArray(cart && cart.cart_level_discount_applications)
      ? cart.cart_level_discount_applications
      : [];
    cartLevelApplications.forEach(collect);
    const items = Array.isArray(cart && cart.items) ? cart.items : [];
    items.forEach((item) => {
      const allocations = Array.isArray(item && item.line_level_discount_allocations)
        ? item.line_level_discount_allocations
        : [];
      allocations.forEach((allocation) => collect(allocation && allocation.discount_application));
    });
    return percentages.length ? Math.max(...percentages) : 0;
  };

  const normalizeDiscountType = (value) => `${value == null ? '' : value}`.trim().toLowerCase();

  const getCartTotalSavingsSummary = (cart, currency = '', template = '') => {
    const originalTotalCents = Number.isFinite(Number(cart && cart.original_total_price))
      ? Number(cart.original_total_price)
      : 0;
    const totalCents = Number.isFinite(Number(cart && cart.total_price))
      ? Number(cart.total_price)
      : originalTotalCents;
    const amountCents = Math.max(0, originalTotalCents - totalCents);
    const percentage = originalTotalCents > 0 && amountCents > 0
      ? Math.round((amountCents / originalTotalCents) * 100)
      : 0;
    return {
      hasSavings: amountCents > 0,
      amountCents,
      amountText: amountCents > 0 ? `-${formatMoney(amountCents, currency)}` : '',
      percentage,
      text: `${template || ''}`.replace(/__PERCENT__/g, `${percentage}`),
    };
  };

  const getItemVariantTitle = (item) => {
    if (!item) return '';
    const value = `${item.variant_title || ''}`.trim();
    if (!value || value === 'Default Title') return '';
    return value;
  };

  const getItemCombinedFinalLinePriceCents = (item) => {
    const originalLinePriceCents = Number.isFinite(Number(item && item.original_line_price))
      ? Number(item.original_line_price)
      : 0;
    const finalLinePriceCents = Number.isFinite(Number(item && item.final_line_price))
      ? Number(item.final_line_price)
      : originalLinePriceCents;
    if (Number.isFinite(item && item.sb_combined_final_line_price)) {
      return Math.max(0, Math.min(finalLinePriceCents, item.sb_combined_final_line_price));
    }
    const discountAllocations = Array.isArray(item && item.discount_allocations)
      ? item.discount_allocations
      : [];
    const exactAllocationAmountCents = discountAllocations.reduce((total, allocation) => {
      const amount = Number(allocation && allocation.amount);
      return Number.isFinite(amount) && amount > 0 ? total + amount : total;
    }, 0);
    if (exactAllocationAmountCents > 0) {
      const allocatedFinalLinePriceCents = Math.max(0, originalLinePriceCents - exactAllocationAmountCents);
      return Math.max(0, Math.min(finalLinePriceCents, allocatedFinalLinePriceCents));
    }

    // Without the matching native section, retain Shopify's line-level price.
    // Order discounts remain reflected in the authoritative cart total.
    return Math.max(0, finalLinePriceCents);
  };

  const renderCartLinePriceStates = ({
    originalLinePriceCents,
    combinedFinalLinePriceCents,
    currency,
  }) => {
    const hasCombinedDiscount = originalLinePriceCents > combinedFinalLinePriceCents;
    const combinedOriginalPrice = formatMoney(originalLinePriceCents, currency);
    const combinedFinalPrice = formatMoney(combinedFinalLinePriceCents, currency);

    return `
      <div class="sb-cart-line__price-state">
        ${
          hasCombinedDiscount
            ? `<p class="sb-cart-line__price sb-cart-line__price--compare font-caption weight-regular">${escapeHtml(
                combinedOriginalPrice
              )}</p>
              <p class="sb-cart-line__discount-price font-caption weight-regular">${escapeHtml(
                combinedFinalPrice
              )}</p>`
            : `<p class="sb-cart-line__price font-caption weight-regular">${escapeHtml(
                combinedFinalPrice
              )}</p>`
        }
      </div>
    `;
  };

  const getItemImageUrl = (item) => {
    if (item && item.featured_image && typeof item.featured_image.url === 'string') {
      return item.featured_image.url;
    }

    if (item && typeof item.image === 'string' && item.image.trim() !== '') {
      return item.image;
    }

    return '';
  };

  const normalizeLineUrl = (value = '') => {
    const raw = `${value || ''}`.trim();
    if (!raw) return '';

    try {
      const parsedUrl = new URL(raw, window.location.origin);
      return `${parsedUrl.pathname}${parsedUrl.search}`;
    } catch (_) {
      return raw;
    }
  };

  const getCartLineIdentity = (item, index) => {
    const key = `${item && item.key ? item.key : ''}`.trim();
    if (key) return `k:${key}`;

    const variantId = Number.parseInt(`${item && item.variant_id ? item.variant_id : ''}`, 10);
    const normalizedVariantId = Number.isFinite(variantId) ? variantId : 0;
    const url = normalizeLineUrl(item && item.url ? item.url : '');
    const line = Number.isFinite(Number(index)) ? Number(index) + 1 : 0;
    return `u:${url}|v:${normalizedVariantId}|l:${line}`;
  };

  const buildItemsSignatureFromCart = (items = []) =>
    items
      .map((item, index) => {
        const identity = getCartLineIdentity(item, index);
        const quantity = clampCount(item && item.quantity ? item.quantity : 0);
        return [identity, quantity].join('|');
      })
      .join('||');

  const setShimmerValue = (node, value = '') => {
    if (!(node instanceof HTMLElement)) return;
    node.setAttribute('data-shimmer-value', `${value == null ? '' : value}`);
  };

  const startTextShimmer = (node) => {
    if (!(node instanceof HTMLElement)) return;
    node.classList.add('sb-cart-shimmer-text');
    setShimmerValue(node, `${node.textContent || ''}`.trim());
    node.setAttribute('shimmer', '');
  };

  const resetTextShimmer = (container = document.body) => {
    if (!(container instanceof Element || container instanceof Document || container instanceof DocumentFragment)) {
      return;
    }
    container.querySelectorAll('[shimmer]').forEach((node) => {
      if (node instanceof HTMLElement) node.removeAttribute('shimmer');
    });
  };

  const CART_ICON_PLUS_SVG =
    '<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.3571 22.6429H0V17.3571H17.3571V0H22.6429V17.3571H40V22.6429H22.6429V40H17.3571V22.6429Z" fill="white"/></svg>';
  const CART_ICON_MINUS_SVG =
    '<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 23.1429V17.8571H40V23.1429H0Z" fill="white"/></svg>';
  const CART_ICON_REMOVE_SVG =
    '<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.5555 40C7.44439 40 6.48143 39.6111 5.66661 38.8333C4.8518 38.0185 4.44439 37.0556 4.44439 35.9444V6.11111H2.22217V2.05556H13.1111V0H26.8888V2.05556H37.7777V6.11111H35.5555V35.9444C35.5555 37.0556 35.1481 38.0185 34.3333 38.8333C33.5185 39.6111 32.5555 40 31.4444 40H8.5555ZM13.4444 31.3889H17.5555V10.6667H13.4444V31.3889ZM22.4444 31.3889H26.5555V10.6667H22.4444V31.3889Z" fill="white"/></svg>';
  const dispatchCartEvents = (cart, source = 'unknown', itemCount = 0, previousCart = null) => {
    const detail = {
      cart,
      source,
      itemCount,
      previousCart,
    };

    document.dispatchEvent(new CustomEvent(EVENTS.cartChanged, { detail }));
    document.dispatchEvent(new CustomEvent('cart:updated', { detail }));
    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart,
          sourceId: 'sb-cart-system',
          data: {
            source,
            itemCount,
          },
        },
      })
    );
  };

  let cachedCart = null;
  let fetchInFlight = null;
  let cartMutationQueue = Promise.resolve();
  let cartMutationPendingCount = 0;
  let nextAddSourceElement = null;
  const pendingPrimaryImageByVariantId = new Map();
  const pendingHoverImageByVariantId = new Map();
  // Authoritative hover sources, rendered server-side with the same rules as
  // the initial cart markup (sb-hover-image-url) and delivered with each cart
  // mutation via the Section Rendering API. The pending/existing maps above
  // remain only as a fallback for payloads that arrive without sections.
  const CART_HOVER_MAP_SECTION_ID = 'sb-cart-hover-map';
  const serverHoverImageByVariantId = new Map();
  const applyCartSectionsPayload = (sections, cart) => {
    const sectionHtml = sections && typeof sections === 'object'
      ? sections[CART_HOVER_MAP_SECTION_ID]
      : '';
    if (typeof sectionHtml !== 'string' || sectionHtml === '') return;
    try {
      const parsed = new DOMParser().parseFromString(sectionHtml, 'text/html');
      const pricesNode = parsed.querySelector('[data-sb-cart-line-prices]');
      if (pricesNode && cart && Array.isArray(cart.items)) {
        const snapshot = JSON.parse(pricesNode.textContent || '{}');
        const lines = snapshot.items;
        // Refresh and add fetch cart/sections separately. Never apply allocations
        // from a different cart state, even when variant IDs are unchanged.
        if (snapshot.currency === cart.currency
          && snapshot.total_price === cart.total_price
          && snapshot.items_subtotal_price === cart.items_subtotal_price
          && Array.isArray(lines) && lines.length === cart.items.length
          && lines.every((line, index) => {
            const item = cart.items[index];
            return line.key === item.key && line.quantity === item.quantity
              && line.original_line_price === item.original_line_price
              && line.final_line_price === item.final_line_price
              && Number.isSafeInteger(line.combined_final_line_price)
              && line.combined_final_line_price >= 0
              && line.combined_final_line_price <= item.final_line_price;
          })) {
          cart.items = cart.items.map((item, index) => ({
            ...item,
            sb_combined_final_line_price: lines[index].combined_final_line_price,
            sb_image: lines[index].image && typeof lines[index].image.src === 'string'
              && typeof lines[index].image.srcset === 'string' ? lines[index].image : null,
          }));
        }
      }
      const dataNode = parsed.querySelector('[data-sb-cart-hover-map]');
      if (!dataNode) return;
      const map = JSON.parse(dataNode.textContent || '{}');
      if (!map || typeof map !== 'object') return;
      serverHoverImageByVariantId.clear();
      Object.keys(map).forEach((variantId) => {
        const url = `${map[variantId] || ''}`.trim();
        if (url) serverHoverImageByVariantId.set(`${variantId}`.trim(), url);
      });
    } catch (_) {}
  };
  const fetchCartHoverMapSection = async ({ signal } = {}) => {
    try {
      const response = await fetch(`${shopRoot}?sections=${CART_HOVER_MAP_SECTION_ID}`, {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
        signal,
      });
      if (!response.ok) return;
      return await response.json();
    } catch (_) {}
  };
  const isCartLikePayload = (value) => {
    if (!value || typeof value !== 'object') return false;
    if (!Array.isArray(value.items)) return false;
    return Number.isFinite(Number(value.item_count));
  };
  const normalizeCartPayload = (cart) => {
    if (!isCartLikePayload(cart)) return cart;
    const applications = Array.isArray(cart.cart_level_discount_applications)
      ? cart.cart_level_discount_applications
      : [];
    const cartLevelDiscountApplications = applications.map((entry) => {
      const nestedApplication =
        entry && typeof entry.discount_application === 'object'
          ? entry.discount_application
          : null;
      if (!nestedApplication) return entry;

      const application = { ...nestedApplication };
      const allocatedAmount = Number(application.total_allocated_amount);
      const wrapperAmount = Number(entry.amount);
      if (
        (!Number.isFinite(allocatedAmount) || allocatedAmount <= 0)
        && Number.isFinite(wrapperAmount)
        && wrapperAmount > 0
      ) {
        application.total_allocated_amount = Math.round(wrapperAmount);
      }
      return application;
    });

    return {
      ...cart,
      cart_level_discount_applications: cartLevelDiscountApplications,
    };
  };
  const createEmptyCartFrom = (cart) => ({
    ...(cart && typeof cart === 'object' ? cart : {}),
    item_count: 0,
    items: [],
    items_subtotal_price: 0,
    original_total_price: 0,
    total_discount: 0,
    total_price: 0,
    cart_level_discount_applications: [],
  });

  const fetchCart = async ({ signal } = {}) => {
    const response = await fetch(cartUrl('cart.js'), {
      method: 'GET',
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
      signal,
    });

    if (!response.ok) {
      throw new Error('Cart fetch failed');
    }

    const cart = await response.json();
    if (!isCartLikePayload(cart)) throw new Error('Invalid cart response');
    return cart;
  };

  const readCartAfterAdd = async (addSections, recover = false) => {
    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), 5000);
    try {
      return await Promise.all([
        fetchCart({ signal: controller.signal }),
        recover ? fetchCartHoverMapSection({ signal: controller.signal }) : addSections,
      ]);
    } finally {
      window.clearTimeout(timeout);
      controller.abort();
    }
  };

  const updateCartAndDispatch = (cart, source, { animateBadge = true, itemCount = 0 } = {}) => {
    const normalizedCart = normalizeCartPayload(cart);
    const previousCart = cachedCart;
    cachedCart = normalizedCart;
    if (Number(normalizedCart && normalizedCart.item_count) > 0) {
      window.SBStorefrontPricing?.setCartDiscountPercentage?.(
        getAppliedCodeDiscountPercentage(normalizedCart),
        { source: `cart:${source}` }
      );
    }
    setHeaderCartCount(normalizedCart && normalizedCart.item_count ? normalizedCart.item_count : 0, {
      animate: animateBadge,
    });
    dispatchCartEvents(normalizedCart, source, itemCount, previousCart);
    return normalizedCart;
  };

  const refreshCart = async ({ source = 'refresh', animateBadge = false } = {}) => {
    if (fetchInFlight) {
      return fetchInFlight;
    }

    const cartAtRequestStart = cachedCart;
    fetchInFlight = Promise.all([fetchCart(), fetchCartHoverMapSection()])
      .then(([cart, sections]) => {
        // A completed mutation or external update supersedes this older read.
        if (cachedCart !== cartAtRequestStart) return cachedCart;
        applyCartSectionsPayload(sections, cart);
        return updateCartAndDispatch(cart, source, { animateBadge });
      })
      .finally(() => {
        fetchInFlight = null;
      });

    return fetchInFlight;
  };

  const serializeCartMutation = (mutation) => {
    cartMutationPendingCount += 1;
    if (cartMutationPendingCount === 1) dispatchCartMutationState(true);
    const result = cartMutationQueue.then(mutation, mutation);
    cartMutationQueue = result.catch(() => {});
    return result.finally(() => {
      cartMutationPendingCount -= 1;
      if (cartMutationPendingCount === 0) dispatchCartMutationState(false);
    });
  };

  const recoverCartAfterMutationFailure = async (source) => {
    const [cart, sections] = await Promise.all([fetchCart(), fetchCartHoverMapSection()]);
    applyCartSectionsPayload(sections, cart);
    return updateCartAndDispatch(cart, `${source}-recovery`, {
      animateBadge: false,
      itemCount: cart.item_count || 0,
    });
  };

  const runCartMutation = ({
    path,
    source,
    requestOptions,
    animateBadge = false,
    errorMessage,
    delay = 0,
  }) =>
    serializeCartMutation(async () => {
      if (delay > 0) await new Promise((resolve) => window.setTimeout(resolve, delay));
      try {
        const response = await fetch(cartUrl(path), requestOptions);
        if (!response.ok) {
          throw new Error(errorMessage);
        }

        const cart = await response.json();
        if (!isCartLikePayload(cart)) {
          throw new Error(errorMessage);
        }

        applyCartSectionsPayload(cart.sections, cart);

        return updateCartAndDispatch(cart, source, {
          animateBadge,
          itemCount: cart.item_count || 0,
        });
      } catch (error) {
        try {
          await recoverCartAfterMutationFailure(source);
        } catch (_) {}
        throw error;
      }
    });

  const getNodeMediaSource = (node) => {
    if (!(node instanceof Element)) return '';
    const tagName = `${node.tagName || ''}`.toLowerCase();
    if (tagName === 'img') {
      const imageNode = /** @type {HTMLImageElement} */ (node);
      return imageNode.currentSrc || imageNode.getAttribute('src') || '';
    }
    if (tagName === 'video') {
      const poster = node.getAttribute('poster') || '';
      if (poster) return poster;
      return node.getAttribute('src') || '';
    }
    return '';
  };

  const getHeroCardMediaSource = (button) => {
    const heroCard = button.closest('.sb-framing-card');
    if (!(heroCard instanceof HTMLElement)) return '';
    const styleValue = `${heroCard.getAttribute('style') || ''}`;
    if (!styleValue) return '';
    const match = styleValue.match(/url\(['"]?([^'")]+)['"]?\)/i);
    return match && match[1] ? match[1] : '';
  };

  const resolveButtonElement = (sourceElement) => {
    if (sourceElement instanceof HTMLButtonElement) return sourceElement;
    if (sourceElement instanceof HTMLFormElement) {
      const formSubmitButton = sourceElement.querySelector(
        'button[type="submit"], button[name="add"], [data-add-to-cart], [data-hero-card-submit], [data-addon-add-to-cart]'
      );
      if (formSubmitButton instanceof HTMLButtonElement) return formSubmitButton;
    }
    if (!(sourceElement instanceof Element)) return null;
    return sourceElement.closest('button, [role="button"]');
  };

  const ensureButtonBurst = (button) => {
    if (!(button instanceof HTMLElement)) return null;
    let burst = button.querySelector('[data-sb-atc-burst]');
    if (burst) return burst;
    ensureAtcAnimationStyles();
    if (window.getComputedStyle(button).position === 'static') {
      button.style.position = 'relative';
    }
    button.classList.add('sb-atc-button');
    burst = document.createElement('span');
    burst.className = 'sb-atc-burst';
    burst.setAttribute('data-sb-atc-burst', 'true');
    burst.setAttribute('aria-hidden', 'true');
    burst.innerHTML = ATC_BURST_SVG;
    button.appendChild(burst);
    return burst;
  };

  const resetButtonSuccess = (sourceElement) => {
    const button = resolveButtonElement(sourceElement);
    if (!button) return;

    const existingTimer = Number.parseInt(button.dataset.sbAtcResetTimer || '', 10);
    if (Number.isFinite(existingTimer)) {
      window.clearTimeout(existingTimer);
    }

    const label = button.querySelector('[data-add-to-cart-label]');
    const defaultLabel = button.dataset.labelDefault || '';
    const successMode = button.dataset.successContent || '';
    const keepsDefaultContent = successMode === 'static' || successMode === 'native';

    button.classList.add('sb-atc-resetting');
    button.removeAttribute('data-added');
    button.classList.remove('is-added');
    if (!keepsDefaultContent && label && defaultLabel) {
      label.textContent = defaultLabel;
    }
    delete button.dataset.sbAtcResetTimer;
    window.requestAnimationFrame(() => button.classList.remove('sb-atc-resetting'));
  };

  const animateButtonSuccess = (sourceElement, { duration = BUTTON_SUCCESS_RESET_DELAY } = {}) => {
    const button = resolveButtonElement(sourceElement);
    if (!button) return;
    ensureAtcAnimationStyles();
    const successMode = button.dataset.successContent || '';
    const usesNativeSuccess = successMode === 'native';
    const shouldAnimateBurst = !prefersReducedMotion() && !usesNativeSuccess;
    if (shouldAnimateBurst) {
      const burst = ensureButtonBurst(button);
      button.removeAttribute('data-added');
      if (burst instanceof HTMLElement) void burst.offsetWidth;
    }
    if (!button.classList.contains('sb-atc-button')) {
      button.classList.add('sb-atc-button');
    }
    const existingTimer = Number.parseInt(button.dataset.sbAtcResetTimer || '', 10);
    if (Number.isFinite(existingTimer)) {
      window.clearTimeout(existingTimer);
    }

    const label = button.querySelector('[data-add-to-cart-label]');
    const addedLabel = button.dataset.labelAdded || '';
    const keepsDefaultContent = successMode === 'static' || usesNativeSuccess;

    const activate = () => {
      button.setAttribute('data-added', 'true');
      button.classList.toggle('is-added', !keepsDefaultContent);
      if (!keepsDefaultContent && label && addedLabel) {
        label.textContent = addedLabel;
      }

      const timerId = window.setTimeout(() => {
        resetButtonSuccess(button);
      }, Math.max(
        250,
        usesNativeSuccess ? NATIVE_BUTTON_SUCCESS_RESET_DELAY : Number(duration) || BUTTON_SUCCESS_RESET_DELAY
      ));
      button.dataset.sbAtcResetTimer = `${timerId}`;
    };

    activate();
  };

  const resolveFlyToCartMode = (sourceElement) => {
    if (!(sourceElement instanceof Element)) return 'fly-to-cart--main';
    if (sourceElement.closest('.sb-product-main__sticky-bar-wrap, .sb-product-main__sticky-bottom-bar-wrap')) {
      return 'fly-to-cart--sticky';
    }
    if (
      sourceElement.closest('.quick-add, .quick-add-modal') ||
      sourceElement.matches('.sb-product-thumbnail__add-to-cart')
    ) {
      return 'fly-to-cart--quick';
    }
    return 'fly-to-cart--main';
  };

  const resolveFlyImageSource = (sourceElement, imageSrc = '') => {
    if (`${imageSrc || ''}`.trim() !== '') return `${imageSrc}`.trim();
    if (!(sourceElement instanceof Element)) return '';

    const thumbnailScope = sourceElement.closest('.sb-product-thumbnail');
    if (thumbnailScope) {
      const thumbnailActiveMedia = thumbnailScope.querySelector(
        '.sb-product-thumbnail__carousel-slide[aria-hidden="false"] .sb-product-thumbnail__media-item'
      );
      const thumbnailActiveSource = getNodeMediaSource(thumbnailActiveMedia);
      if (thumbnailActiveSource) return thumbnailActiveSource;

      const thumbnailFallbackMedia = thumbnailScope.querySelector('.sb-product-thumbnail__media-item');
      const thumbnailFallbackSource = getNodeMediaSource(thumbnailFallbackMedia);
      if (thumbnailFallbackSource) return thumbnailFallbackSource;
    }

    const addonScope = sourceElement.closest('.sb-product-main__popular-addon-item');
    if (addonScope) {
      const addonImage = addonScope.querySelector('[data-addon-image] img, [data-addon-image]');
      const addonImageSource = getNodeMediaSource(addonImage);
      if (addonImageSource) return addonImageSource;
    }

    const productScope = sourceElement.closest('.sb-product-main');
    if (productScope) {
      const productMedia = productScope.querySelector(
        '.sb-product-main__media-item:first-child .sb-product-main__media-asset, .sb-product-main__media-asset'
      );
      const productMediaSource = getNodeMediaSource(productMedia);
      if (productMediaSource) return productMediaSource;
    }

    const heroMediaSource = getHeroCardMediaSource(sourceElement);
    if (heroMediaSource) return heroMediaSource;

    const nearestImage = sourceElement.closest('article, section, form, .shopify-section')?.querySelector('img');
    const nearestImageSource = getNodeMediaSource(nearestImage);
    if (nearestImageSource) return nearestImageSource;

    return '';
  };

  const resolveCartPrimaryImageSource = (sourceElement, variantId = '', fallbackSource = '') => {
    if (!(sourceElement instanceof Element)) return `${fallbackSource || ''}`.trim();

    const thumbnailScope = sourceElement.closest('.sb-product-thumbnail');
    if (!(thumbnailScope instanceof HTMLElement)) return `${fallbackSource || ''}`.trim();

    const selectedSwatch = thumbnailScope.querySelector('.sb-product-thumbnail__swatch.is-selected');
    if (selectedSwatch instanceof HTMLElement) {
      const selectedVariantId = `${selectedSwatch.dataset.thumbnailVariantId || ''}`.trim();
      const selectedImage = `${selectedSwatch.dataset.thumbnailImage || ''}`.trim();
      if (selectedImage && (!selectedVariantId || selectedVariantId === `${variantId || ''}`)) {
        return selectedImage;
      }
    }

    const mediaWrap = thumbnailScope.querySelector('.sb-product-thumbnail__media-wrap');
    if (mediaWrap instanceof HTMLElement) {
      const primaryImage = `${mediaWrap.dataset.primaryImage || mediaWrap.dataset.defaultImage || ''}`.trim();
      if (primaryImage) return primaryImage;

      const galleryData = mediaWrap.querySelector('[data-thumbnail-gallery-json]');
      if (galleryData instanceof HTMLScriptElement) {
        try {
          const galleryItems = JSON.parse(galleryData.textContent || '[]');
          const primaryItem = Array.isArray(galleryItems) ? galleryItems[0] : null;
          const primarySource = primaryItem?.type === 'video'
            ? `${primaryItem.poster || primaryItem.src || ''}`.trim()
            : `${primaryItem?.src || ''}`.trim();
          if (primarySource) return primarySource;
        } catch (_) {
          // Fall back to the visible fly image when gallery data is unavailable.
        }
      }
    }

    return `${fallbackSource || ''}`.trim();
  };

  const getVisibleFlySource = (element) => {
    if (!(element instanceof Element)) return null;
    const rect = element.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0 ? element : null;
  };

  const resolveStickyFlySource = (sourceElement) => {
    if (!(sourceElement instanceof Element)) return null;

    const topStickyBar = sourceElement.closest('.sb-product-main__sticky-bar-wrap');
    if (topStickyBar) {
      return getVisibleFlySource(topStickyBar.querySelector('[data-sticky-image]'));
    }

    const bottomStickyBar = sourceElement.closest('.sb-product-main__sticky-bottom-bar-wrap');
    if (bottomStickyBar) {
      return getVisibleFlySource(bottomStickyBar.querySelector('.sb-product-main__sticky-bottom-image'));
    }

    return null;
  };

  const resolveFlyToCartConfig = ({ sourceElement, imageSrc }) => {
    const stickyFlySource = resolveStickyFlySource(sourceElement);
    const resolvedSourceElement = stickyFlySource || sourceElement;
    const stickyImageSource = stickyFlySource ? getNodeMediaSource(stickyFlySource) : '';
    const resolvedImageSource =
      `${imageSrc || ''}`.trim() || stickyImageSource || resolveFlyImageSource(sourceElement, imageSrc);

    return {
      className: resolveFlyToCartMode(sourceElement),
      imageSrc: resolvedImageSource,
      sourceElement: resolvedSourceElement,
      useSourceSize: Boolean(stickyFlySource),
    };
  };

  const resolveMappedHoverImageSource = (scope, selector, variantId) => {
    if (!(scope instanceof Element)) return '';
    const hoverImageData = scope.querySelector(selector);
    if (!(hoverImageData instanceof HTMLScriptElement)) return '';

    try {
      const hoverImageMap = JSON.parse(hoverImageData.textContent || '{}');
      return `${hoverImageMap?.[`${variantId || ''}`] || ''}`.trim();
    } catch (_) {
      return '';
    }
  };

  const resolveCartLineHoverImageSource = (sourceElement, variantId = '') => {
    if (!(sourceElement instanceof Element)) return '';

    const cartLine = sourceElement.closest('[data-cart-line]');
    if (cartLine instanceof HTMLElement) {
      const rowHoverImage = `${cartLine.getAttribute('data-cart-hover-image') || ''}`.trim();
      if (rowHoverImage) return rowHoverImage;
    }

    const thumbnailScope = sourceElement.closest('.sb-product-thumbnail');
    if (thumbnailScope instanceof HTMLElement) {
      const selectedSwatch = thumbnailScope.querySelector('.sb-product-thumbnail__swatch.is-selected');
      if (selectedSwatch instanceof HTMLElement) {
        const swatchHoverImage = `${selectedSwatch.dataset.thumbnailHoverImage || ''}`.trim();
        if (swatchHoverImage) return swatchHoverImage;
      }
    }

    const mediaWrap = sourceElement.closest('.sb-product-thumbnail__media-wrap');
    if (mediaWrap instanceof HTMLElement) {
      const mediaWrapHoverImage = `${mediaWrap.dataset.hoverImage || ''}`.trim();
      if (mediaWrapHoverImage) return mediaWrapHoverImage;

      const galleryData = mediaWrap.querySelector('[data-thumbnail-gallery-json]');
      if (galleryData instanceof HTMLScriptElement) {
        try {
          const galleryItems = JSON.parse(galleryData.textContent || '[]');
          if (Array.isArray(galleryItems) && galleryItems.length > 1) {
            const configuredIndex = Number.parseInt(`${mediaWrap.dataset.hoverMediaIndex || ''}`, 10);
            const hoverIndex = Number.isFinite(configuredIndex) && configuredIndex > 1 && configuredIndex <= galleryItems.length
              ? configuredIndex - 1
              : 1;
            const hoverItem = galleryItems[hoverIndex];
            const hoverSource = hoverItem && hoverItem.type === 'video'
              ? `${hoverItem.poster || ''}`.trim()
              : `${hoverItem && hoverItem.src ? hoverItem.src : ''}`.trim();
            if (hoverSource) return hoverSource;
          }
        } catch (_) {}
      }
    }

    const addonItem = sourceElement.closest('[data-addon-item]');
    if (addonItem instanceof Element) {
      return resolveMappedHoverImageSource(addonItem, '[data-addon-hover-map-json]', variantId);
    }

    const productSurface = sourceElement.closest(
      '[data-sb-product-top-sticky-accessory-bar], [data-product-grid-content]'
    );
    const productHoverImage = productSurface?.querySelector(
      '[data-sticky-hover-image], [data-sticky-bottom-hover-image]'
    );
    const productHoverSource = `${productHoverImage?.getAttribute('src') || ''}`.trim()
      || getNodeMediaSource(productHoverImage);
    if (productHoverSource) return productHoverSource;

    return '';
  };

  const animateFlyToCart = ({ sourceElement, imageSrc, resolvedConfig = null }) => {
    if (!(sourceElement instanceof Element)) return;
    if (prefersReducedMotion()) return;
    const cartTrigger = document.querySelector('[data-header-cart-link]');
    if (!(cartTrigger instanceof Element)) return;
    const flyConfig = resolvedConfig || resolveFlyToCartConfig({ sourceElement, imageSrc });
    if (!flyConfig.imageSrc) return;

    ensureAtcAnimationStyles();

    const flyNode = document.createElement('fly-to-cart');
    flyNode.classList.add(flyConfig.className);
    flyNode.style.setProperty('background-image', `url("${flyConfig.imageSrc.replace(/"/g, '\\"')}")`);
    flyNode.style.setProperty('--start-opacity', '0');
    if (flyConfig.useSourceSize) {
      flyNode.dataset.useSourceSize = 'true';
    }
    flyNode.sourceElement = flyConfig.sourceElement;
    flyNode.destinationElement = cartTrigger;
    document.body.appendChild(flyNode);
  };

  const surfaceAddToCartError = (error) => {
    const drawer = document.querySelector('cart-drawer-component');
    const items = isOnCartPage
      ? document.querySelector('cart-items-component[data-context="page"]')
      : (drawer ? drawer.querySelector('cart-items-component') : null);
    if (!items || typeof items.showStatus !== 'function') return;
    const message = (error && error.cartDescription) || items.addErrorMessage;
    if (!message) return;
    if (!isOnCartPage && drawer && typeof drawer.open === 'function') {
      drawer.open();
    }
    items.showStatus(message);
  };

  const addToCart = (
    variantId,
    {
      quantity = 1,
      sourceElement = null,
      imageSrc = '',
    } = {}
  ) => serializeCartMutation(async () => {
    const variantIdValue = `${variantId || ''}`.trim();
    const normalizedQuantity = clampCount(quantity);

    if (!variantIdValue) {
      throw new Error('Invalid variant id');
    }

    if (normalizedQuantity <= 0) {
      throw new Error('Invalid quantity');
    }

    const flyConfig = sourceElement instanceof Element
      ? resolveFlyToCartConfig({ sourceElement, imageSrc })
      : null;
    const normalizedVariantId = Number.parseInt(variantIdValue, 10);
    if (Number.isFinite(normalizedVariantId) && normalizedVariantId > 0) {
      const primaryImage = resolveCartPrimaryImageSource(
        sourceElement,
        normalizedVariantId,
        flyConfig?.imageSrc || imageSrc || ''
      );
      if (primaryImage) {
        pendingPrimaryImageByVariantId.set(`${normalizedVariantId}`, primaryImage);
      }
      const hoverImage = resolveCartLineHoverImageSource(sourceElement, normalizedVariantId);
      if (hoverImage) {
        pendingHoverImageByVariantId.set(`${normalizedVariantId}`, hoverImage);
      }
    }

    animateFlyToCart({ sourceElement, imageSrc, resolvedConfig: flyConfig });
    animateButtonSuccess(sourceElement);

    const formData = new FormData();
    formData.append('id', variantIdValue);
    formData.append('quantity', `${normalizedQuantity}`);
    formData.append('sections', CART_HOVER_MAP_SECTION_ID);

    const cartBeforeAdd = cachedCart;
    const variantQuantity = (cart) => (cart?.items || []).reduce((total, item) => (
      `${item.variant_id || item.id}` === variantIdValue ? total + clampCount(item.quantity) : total
    ), 0);
    let addSucceeded = false;
    let addError = null;
    let addSections;
    try {
      const response = await fetch(cartUrl('cart/add.js'), {
        method: 'POST',
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
        body: formData,
      });

      if (!response.ok) {
        const body = await response.text();
        const error = new Error(`Add to cart failed: ${body || response.status}`);
        try {
          const parsed = JSON.parse(body);
          error.cartDescription = `${parsed.description || parsed.message || ''}`.trim();
        } catch (_) {}
        throw error;
      }

      addSucceeded = true;
      try {
        const addPayload = await response.json();
        addSections = addPayload && addPayload.sections;
      } catch (_) {}
    } catch (error) {
      addError = error;
    }

    // Even a stock error or a lost add response can leave the cart changed.
    // Retry only the read after a confirmed add; never repeat the POST.
    let cart;
    let sections;
    try {
      [cart, sections] = await readCartAfterAdd(addSections, !addSucceeded);
    } catch (_) {
      if (addSucceeded) {
        try {
          [cart, sections] = await readCartAfterAdd(undefined, true);
        } catch (_) {}
      }
      if (!cart) {
        // We cannot safely show stale quantities or invite another add.
        window.location.assign(cartUrl('cart'));
        return null;
      }
    }

    const addedQuantity = cartBeforeAdd
      ? Math.max(0, variantQuantity(cart) - variantQuantity(cartBeforeAdd))
      : (addSucceeded ? normalizedQuantity : 0);
    const didAdd = addSucceeded || addedQuantity > 0;
    // Without an initial snapshot, an existing variant cannot prove failure.
    const hasUncertainAdd = !cartBeforeAdd && variantQuantity(cart) > 0;
    applyCartSectionsPayload(sections, cart);
    cart = updateCartAndDispatch(cart, didAdd ? 'add' : 'add-recovery', {
      animateBadge: didAdd,
      itemCount: addedQuantity,
    });

    if (addError && ((!didAdd && !hasUncertainAdd) || addError.cartDescription)) {
      surfaceAddToCartError(addError);
    }
    if (!didAdd && !hasUncertainAdd) {
      resetButtonSuccess(sourceElement);
      throw addError;
    }

    const drawer = document.querySelector('cart-drawer-component');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
    }

    return cart;
  });

  const dispatchCartMutationState = (pending) => {
    document.dispatchEvent(new CustomEvent(EVENTS.mutationState, {
      detail: { pending },
    }));
  };

  const changeLine = (
    line,
    quantity,
    { source = 'change', animateBadge = false, delay = 0 } = {}
  ) => {
    const normalizedLine = Number.parseInt(`${line}`, 10);
    const normalizedQuantity = clampCount(quantity);
    const normalizedDelay = Math.max(0, Number.parseInt(`${delay}`, 10) || 0);

    if (!Number.isFinite(normalizedLine) || normalizedLine <= 0) {
      return Promise.reject(new Error('Invalid line'));
    }
    if (cartMutationPendingCount > 0) {
      return Promise.reject(new Error('Cart change already in progress'));
    }

    return runCartMutation({
      path: 'cart/change.js',
      delay: normalizedDelay,
      source,
      animateBadge,
      errorMessage: 'Cart change failed',
      requestOptions: {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        credentials: 'same-origin',
        body: JSON.stringify({
          line: normalizedLine,
          quantity: normalizedQuantity,
          sections: CART_HOVER_MAP_SECTION_ID,
        }),
      },
    });
  };

  const clearCart = async ({ source = 'clear' } = {}) => {
    return runCartMutation({
      path: 'cart/clear.js',
      source,
      errorMessage: 'Cart clear failed',
      requestOptions: {
        method: 'POST',
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
      },
    });
  };

  const updateAttributes = async (attributes, { source = 'attributes' } = {}) => {
    const normalizedAttributes = attributes && typeof attributes === 'object' ? attributes : {};
    return runCartMutation({
      path: 'cart/update.js',
      source,
      errorMessage: 'Cart attribute update failed',
      requestOptions: {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        credentials: 'same-origin',
        body: JSON.stringify({ attributes: normalizedAttributes, sections: CART_HOVER_MAP_SECTION_ID }),
      },
    });
  };

  const applyDiscount = (discountCodes, { source = 'discount', commit = true } = {}) => serializeCartMutation(async () => {
    const normalizedCodes = normalizeStringArray(discountCodes);

    const response = await fetch(cartUrl('cart/update.js'), {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        discount: normalizedCodes.join(','),
        sections: CART_HOVER_MAP_SECTION_ID,
      }),
    });

    if (!response.ok) {
      throw new Error('Cart discount update failed');
    }

    const cart = await response.json();
    applyCartSectionsPayload(cart.sections, cart);
    if (!commit) return cart;

    try {
      const freshCart = await fetchCart();
      applyCartSectionsPayload(cart.sections, freshCart);
      return updateCartAndDispatch(freshCart, source, {
        animateBadge: false,
        itemCount: freshCart.item_count || 0,
      });
    } catch (_) {
      return updateCartAndDispatch(cart, source, {
        animateBadge: false,
        itemCount: cart.item_count || 0,
      });
    }
  });

  class CartDrawerComponent extends HTMLElement {
    connectedCallback() {
      this.drawer = this.querySelector('[data-cart-drawer]');
      this.panel = this.querySelector('[data-cart-drawer-panel]');
      this.closeControls = this.querySelectorAll('[data-cart-drawer-close]');
      this.trigger = document.querySelector('[data-header-cart-link]');
      this.historyAbortController = null;
      this.panelTransitionTimer = 0;
      this.deferredImageIdleHandle = 0;
      this.deferredImageTimeout = 0;
      this.deferredImagePreloadScheduled = false;
      this.isCartPage = this.trigger
        ? this.trigger.dataset.headerCartPage === 'true'
        : isOnCartPage;

      if (!this.drawer || !this.panel) return;
      if (this.isCartPage) return;

      this.boundHandleTriggerClick = this.handleTriggerClick.bind(this);
      this.boundHandleCloseClick = this.handleCloseClick.bind(this);
      this.boundHandleEscape = this.handleEscape.bind(this);
      this.boundHandleFocusTrap = this.handleFocusTrap.bind(this);
      this.boundHandleCartChange = this.handleCartChange.bind(this);
      this.boundHandleResize = this.handleResize.bind(this);
      this.boundHandlePopState = this.handlePopState.bind(this);
      this.boundScheduleDeferredImagePreload = this.scheduleDeferredImagePreload.bind(this);

      if (this.trigger) {
        this.trigger.addEventListener('click', this.boundHandleTriggerClick);
      }

      this.closeControls.forEach((node) => {
        node.addEventListener('click', this.boundHandleCloseClick);
      });

      document.addEventListener('keydown', this.boundHandleEscape);
      document.addEventListener('keydown', this.boundHandleFocusTrap);
      document.addEventListener(EVENTS.cartChanged, this.boundHandleCartChange);
      window.addEventListener('resize', this.boundHandleResize, { passive: true });

      if (document.readyState === 'complete') {
        this.scheduleDeferredImagePreload();
      } else {
        window.addEventListener('load', this.boundScheduleDeferredImagePreload, { once: true });
      }
      if (this.isOpen) {
        this.trigger?.setAttribute('aria-expanded', 'true');
        this.setupHistoryListener();
        this.updateStickyState();
        this.dispatchStateChange({ open: true, settled: true });
      }
    }

    disconnectedCallback() {
      if (this.trigger && this.boundHandleTriggerClick) {
        this.trigger.removeEventListener('click', this.boundHandleTriggerClick);
      }

      if (this.closeControls && this.boundHandleCloseClick) {
        this.closeControls.forEach((node) => {
          node.removeEventListener('click', this.boundHandleCloseClick);
        });
      }

      if (this.boundHandleEscape) {
        document.removeEventListener('keydown', this.boundHandleEscape);
      }

      if (this.boundHandleFocusTrap) {
        document.removeEventListener('keydown', this.boundHandleFocusTrap);
      }

      if (this.boundHandleCartChange) {
        document.removeEventListener(EVENTS.cartChanged, this.boundHandleCartChange);
      }

      if (this.boundHandleResize) {
        window.removeEventListener('resize', this.boundHandleResize);
      }

      if (this.boundScheduleDeferredImagePreload) {
        window.removeEventListener('load', this.boundScheduleDeferredImagePreload);
      }

      if (this.deferredImageIdleHandle && typeof window.cancelIdleCallback === 'function') {
        window.cancelIdleCallback(this.deferredImageIdleHandle);
      }

      if (this.deferredImageTimeout) {
        window.clearTimeout(this.deferredImageTimeout);
      }

      this.teardownHistoryListener();
      this.clearPanelTransitionGuard();
      this.trigger?.setAttribute('aria-expanded', 'false');
      // The shared lock owner derives its state from connected surfaces.
      this.dispatchStateChange({ open: this.isConnected && this.isOpen, settled: true });
    }

    get isOpen() {
      return Boolean(this.drawer && !this.drawer.hasAttribute('hidden'));
    }

    hydrateDeferredImages() {
      this.querySelectorAll('img[data-sb-cart-deferred-image]').forEach((image) => {
        const sizes = image.getAttribute('data-sb-cart-deferred-sizes');
        const srcset = image.getAttribute('data-sb-cart-deferred-srcset');
        const src = image.getAttribute('data-sb-cart-deferred-src');

        if (sizes) image.setAttribute('sizes', sizes);
        if (srcset) image.setAttribute('srcset', srcset);
        if (src) image.setAttribute('src', src);

        image.removeAttribute('data-sb-cart-deferred-image');
        image.removeAttribute('data-sb-cart-deferred-sizes');
        image.removeAttribute('data-sb-cart-deferred-srcset');
        image.removeAttribute('data-sb-cart-deferred-src');
      });
    }

    scheduleDeferredImagePreload() {
      if (this.deferredImagePreloadScheduled) return;
      this.deferredImagePreloadScheduled = true;

      if (typeof window.requestIdleCallback === 'function') {
        this.deferredImageIdleHandle = window.requestIdleCallback(() => {
          this.deferredImageIdleHandle = 0;
          this.hydrateDeferredImages();
        }, { timeout: 2000 });
        return;
      }

      this.deferredImageTimeout = window.setTimeout(() => {
        this.deferredImageTimeout = 0;
        this.hydrateDeferredImages();
      }, 180);
    }

    isMobileBreakpoint() {
      return window.matchMedia('(max-width: 989px)').matches;
    }

    handleTriggerClick(event) {
      if (this.isCartPage) return;
      if (event) event.preventDefault();
      if (this.isOpen) {
        this.close();
        return;
      }
      this.open();
    }

    handleCloseClick(event) {
      if (event) event.preventDefault();
      this.close();
    }

    handleEscape(event) {
      if (event.key !== 'Escape') return;
      if (!this.isOpen) return;
      this.close();
    }

    /* The panel declares aria-modal="true", which promises assistive tech
       the background is inert - keyboard Tab has to keep that promise. */
    handleFocusTrap(event) {
      if (event.key !== 'Tab' || !this.isOpen || !this.panel) return;
      const focusables = [
        ...this.panel.querySelectorAll('button, input, select, textarea, a[href], [tabindex]:not([tabindex="-1"])'),
      ].filter((el) => el.tabIndex >= 0 && !el.matches(':disabled') && !el.closest('[inert]')
        && el.getClientRects().length > 0 && getComputedStyle(el).visibility === 'visible');
      if (focusables.length === 0) {
        this.panel.focus();
        event.preventDefault();
        return;
      }
      const first = focusables[0];
      const last = focusables[focusables.length - 1];
      const active = document.activeElement;
      if (!this.panel.contains(active)) {
        (event.shiftKey ? last : first).focus();
        event.preventDefault();
      } else if (event.shiftKey && (active === first || active === this.panel)) {
        last.focus();
        event.preventDefault();
      } else if (!event.shiftKey && active === last) {
        first.focus();
        event.preventDefault();
      }
    }

    handleCartChange(event) {
      if (!event || !event.detail) return;
      if (event.detail.source === 'add' && this.hasAttribute('auto-open')) {
        this.open();
      }
      this.updateStickyState();
    }

    handleResize() {
      if (!this.isOpen) return;
      this.updateStickyState();
    }

    startPanelTransitionGuard() {
      this.clearPanelTransitionGuard();
      this.dataset.cartDrawerTransitioning = 'true';
      // Use the authored duration instead of transitionend. In WebKit, a
      // closing transitionend can arrive just after a rapid reopen and would
      // otherwise clear the new opening guard on its first frame.
      this.panelTransitionTimer = window.setTimeout(() => {
        this.clearPanelTransitionGuard();
        if (this.isOpen) {
          this.dispatchStateChange({ open: true, settled: true });
        }
      }, CART_DRAWER_OPEN_SETTLE_DURATION);
    }

    clearPanelTransitionGuard() {
      if (this.panelTransitionTimer) window.clearTimeout(this.panelTransitionTimer);
      this.panelTransitionTimer = 0;
      delete this.dataset.cartDrawerTransitioning;
    }

    dispatchStateChange(detail = {}) {
      document.dispatchEvent(new CustomEvent(EVENTS.drawerState, { detail }));
    }

    setupHistoryListener() {
      if (!this.isMobileBreakpoint()) return;

      if (!history.state || !history.state.sbCartDrawerOpen) {
        history.pushState({ ...(history.state || {}), sbCartDrawerOpen: true }, '');
      }

      this.historyAbortController = new AbortController();
      window.addEventListener('popstate', this.boundHandlePopState, {
        signal: this.historyAbortController.signal,
      });
    }

    teardownHistoryListener() {
      if (!this.historyAbortController) return;
      this.historyAbortController.abort();
      this.historyAbortController = null;
    }

    handlePopState() {
      if (!this.isOpen) return;
      this.close({ immediate: true, skipHistory: true });
    }

    open() {
      if (this.isCartPage) return;
      if (!this.drawer || !this.panel || this.isOpen) return;

      this.hydrateDeferredImages();
      this.lastFocused = document.activeElement;
      // the hidden attribute drives the slide-in via @starting-style and the
      // slide-out via the allow-discrete display hold - no class choreography
      this.startPanelTransitionGuard();
      this.drawer.removeAttribute('hidden');
      this.panel.focus({ preventScroll: true });
      this.updateStickyState();
      this.dispatchStateChange({ open: true, settled: false });

      if (this.trigger) {
        this.trigger.setAttribute('aria-expanded', 'true');
      }

      this.setupHistoryListener();

    }

    close({ immediate = false, skipHistory = false } = {}) {
      if (!this.drawer || this.drawer.hasAttribute('hidden')) return;
      if (immediate) this.clearPanelTransitionGuard();
      else this.startPanelTransitionGuard();

      if (this.lastFocused instanceof HTMLElement && this.contains(document.activeElement)) {
        this.lastFocused.focus({ preventScroll: true });
      }
      this.lastFocused = null;

      if (immediate) {
        // suppress the allow-discrete display hold so the drawer vanishes
        // with the platform-back gesture instead of sliding out
        this.drawer.style.transitionProperty = 'none';
        window.requestAnimationFrame(() => {
          if (this.drawer) this.drawer.style.transitionProperty = '';
        });
      }
      this.drawer.setAttribute('hidden', '');
      if (this.trigger) {
        this.trigger.setAttribute('aria-expanded', 'false');
      }
      this.dispatchStateChange({ open: false, settled: true });

      this.teardownHistoryListener();

      if (!skipHistory && this.isMobileBreakpoint() && history.state && history.state.sbCartDrawerOpen) {
        history.back();
      }
    }

    updateStickyState() {
      if (!this.panel) return;

      const summary = this.panel.querySelector('[data-cart-summary]');
      if (!(summary instanceof HTMLElement) || summary.hidden) {
        this.panel.setAttribute('cart-summary-sticky', 'false');
        return;
      }

      const panelHeight = this.panel.getBoundingClientRect().height;
      const summaryHeight = summary.getBoundingClientRect().height;

      if (!panelHeight || !summaryHeight) {
        this.panel.setAttribute('cart-summary-sticky', 'false');
        return;
      }

      const ratio = summaryHeight / panelHeight;
      this.panel.setAttribute('cart-summary-sticky', ratio > 0.5 ? 'false' : 'true');
    }
  }

  class CartItemsComponent extends HTMLElement {
    connectedCallback() {
      this.context = this.dataset.context || 'drawer';
      this.pendingItemKeys = new Set();
      this.cartMutationPending = cartMutationPendingCount > 0;
      this.hasRenderedCartState = false;
      this.lastRenderedItemsSignature = '';
      this.didInitialHydration = false;
      this.messageScopeNode =
        this.context === 'drawer'
          ? this.closest('[data-cart-drawer-panel]') || this
          : this;

      this.statusNode = this.messageScopeNode.querySelector('[data-cart-status]');
      this.statusTextNode = this.statusNode
        ? this.statusNode.querySelector('[data-cart-status-text]')
        : null;
      this.pageHeaderNode = this.messageScopeNode.querySelector('[data-cart-page-header]');
      this.emptyMessageNodes = this.messageScopeNode.querySelectorAll('[data-cart-empty-message]');
      this.filledMessageNodes = this.messageScopeNode.querySelectorAll('[data-cart-filled-message]');
      this.itemListNode = this.querySelector('[data-cart-item-list]');
      this.emptyNode = this.querySelector('[data-cart-empty]');
      this.summaryNode = this.querySelector('[data-cart-summary]');
      this.summaryDividerNode = this.querySelector('[data-cart-summary-divider]');
      this.totalNode = this.querySelector('[data-cart-total]');
      this.autoDiscountRowNode = this.querySelector('[data-cart-auto-discount-row]');
      this.totalSavingsTextNode = this.querySelector('[data-cart-total-savings-text]');
      this.totalSavingsAmountNode = this.querySelector('[data-cart-total-savings-amount]');
      this.freeShippingNode = this.messageScopeNode.querySelector('[data-cart-free-shipping]');
      this.freeShippingMessageNode = this.messageScopeNode.querySelector('[data-cart-free-shipping-message]');
      this.freeShippingProgressRowNode = this.messageScopeNode.querySelector(
        '[data-cart-free-shipping-progress-row]'
      );
      this.freeShippingTrackFillNode = this.messageScopeNode.querySelector('[data-cart-free-shipping-track-fill]');
      this.freeShippingTrackStartCapNode = this.messageScopeNode.querySelector(
        '[data-cart-free-shipping-track-start-cap]'
      );
      this.freeShippingTrackEndCapNode = this.messageScopeNode.querySelector(
        '[data-cart-free-shipping-track-end-cap]'
      );
      this.freeShippingIntroFillNode = this.messageScopeNode.querySelector('[data-cart-free-shipping-intro-fill]');
      this.freeShippingMilestoneFillNode = this.messageScopeNode.querySelector('[data-cart-free-shipping-milestone-fill]');
      this.freeShippingOutroFillNode = this.messageScopeNode.querySelector('[data-cart-free-shipping-outro-fill]');
      this.freeShippingDisplayedPercent = 0;
      this.freeShippingDisplayedDistance = 0;
      this.freeShippingTargetPercent = 0;
      this.freeShippingTargetReached = false;
      this.freeShippingProgressPending = false;
      this.freeShippingCelebratePending = false;
      this.freeShippingHasPresented = false;
      this.freeShippingFlushScheduled = false;
      this.freeShippingAnimationFrame = 0;
      this.freeShippingResizeObserver = null;
      this.checkoutButtons = this.querySelectorAll('[data-cart-checkout-button]');
      this.placeholderImage = this.dataset.placeholderImage || '';
      this.displayCurrency = `${this.dataset.currency || ''}`.trim().toUpperCase();
      this.totalSavingsTemplate = `${this.dataset.totalSavingsTemplate || ''}`.trim();
      this.productNameLabel = `${this.dataset.productNameLabel || ''}`.trim();
      this.quantityLabel = `${this.dataset.quantityLabel || ''}`.trim();
      this.decreaseQuantityLabel = `${this.dataset.decreaseQuantityLabel || ''}`.trim();
      this.increaseQuantityLabel = `${this.dataset.increaseQuantityLabel || ''}`.trim();
      this.removeItemLabel = `${this.dataset.removeItemLabel || ''}`.trim();
      this.updateErrorMessage = `${this.dataset.updateError || ''}`.trim();
      this.removeErrorMessage = `${this.dataset.removeError || ''}`.trim();
      this.addErrorMessage = `${this.dataset.addError || ''}`.trim();
      prepareCartHoverImages(this);
      this.lastRenderedItemsSignature = (() => {
        if (!(this.itemListNode instanceof HTMLElement)) return '';
        const rows = Array.from(this.itemListNode.querySelectorAll('[data-cart-line]'));
        if (!rows.length) return '';
        return rows
          .map((row, index) => {
            if (!(row instanceof HTMLElement)) return '|0';
            const lineNumber = Number.parseInt(`${row.getAttribute('data-cart-line') || ''}`, 10);
            const normalizedLineNumber = Number.isFinite(lineNumber) ? lineNumber : index + 1;
            const key = `${row.getAttribute('data-cart-item-key') || ''}`.trim();
            const variantId = Number.parseInt(`${row.getAttribute('data-cart-variant-id') || ''}`, 10);
            const normalizedVariantId = Number.isFinite(variantId) ? variantId : 0;
            const lineLink =
              row.querySelector('.sb-cart-line__title, .sb-cart-line__media');
            const href =
              lineLink instanceof HTMLAnchorElement
                ? normalizeLineUrl(lineLink.getAttribute('href') || lineLink.href || '')
                : '';
            const qtyInput = row.querySelector('[data-cart-qty-input]');
            const quantity = qtyInput instanceof HTMLInputElement ? clampCount(qtyInput.value) : 0;
            const identity = key ? `k:${key}` : `u:${href}|v:${normalizedVariantId}|l:${normalizedLineNumber}`;
            return [identity, quantity].join('|');
          })
          .join('||');
      })();

      this.boundHandleCartChanged = this.handleCartChanged.bind(this);
      this.boundHandleClick = this.handleClick.bind(this);
      this.boundHandleChange = this.handleChange.bind(this);
      this.boundHandleFocusIn = this.handleFocusIn.bind(this);
      this.boundHandleSubmit = this.handleSubmit.bind(this);
      this.boundHandleDrawerStateChange = this.handleDrawerStateChange.bind(this);
      this.boundHandleMutationStateChange = this.handleMutationStateChange.bind(this);

      document.addEventListener(EVENTS.cartChanged, this.boundHandleCartChanged);
      document.addEventListener(EVENTS.drawerState, this.boundHandleDrawerStateChange);
      document.addEventListener(EVENTS.mutationState, this.boundHandleMutationStateChange);
      this.addEventListener('click', this.boundHandleClick);
      this.addEventListener('change', this.boundHandleChange);
      this.addEventListener('focusin', this.boundHandleFocusIn);
      this.addEventListener('submit', this.boundHandleSubmit);

      this.initializeFreeShippingProgress();

      if (cachedCart) {
        // Newly rendered section markup can be newer than the in-memory cart.
        if (this.itemListNode?.querySelector('[data-cart-line]')
          && !this.shouldPreserveInitialMarkup(cachedCart)) {
          refreshCart({ source: 'section-load', animateBadge: false }).catch(() => {});
          return;
        }
        const preserveInitialMarkup =
          !this.didInitialHydration &&
          this.shouldPreserveInitialMarkup(cachedCart);
        this.didInitialHydration = true;
        this.render(cachedCart, {
          source: 'initial',
          preserveInitialMarkup,
        });
      }
    }

    disconnectedCallback() {
      if (this.boundHandleCartChanged) {
        document.removeEventListener(EVENTS.cartChanged, this.boundHandleCartChanged);
      }
      if (this.boundHandleDrawerStateChange) {
        document.removeEventListener(EVENTS.drawerState, this.boundHandleDrawerStateChange);
      }
      if (this.boundHandleMutationStateChange) {
        document.removeEventListener(EVENTS.mutationState, this.boundHandleMutationStateChange);
      }
      if (this.boundHandleClick) {
        this.removeEventListener('click', this.boundHandleClick);
      }
      if (this.boundHandleChange) {
        this.removeEventListener('change', this.boundHandleChange);
      }
      if (this.boundHandleFocusIn) {
        this.removeEventListener('focusin', this.boundHandleFocusIn);
      }
      if (this.boundHandleSubmit) {
        this.removeEventListener('submit', this.boundHandleSubmit);
      }
      if (this.freeShippingAnimationFrame) {
        window.cancelAnimationFrame(this.freeShippingAnimationFrame);
        this.freeShippingAnimationFrame = 0;
      }
      this.freeShippingResizeObserver?.disconnect();
      this.freeShippingResizeObserver = null;
    }

    initializeFreeShippingProgress() {
      if (!(this.freeShippingNode instanceof HTMLElement)) return;

      if (this.freeShippingTrackFillNode instanceof HTMLElement) {
        this.freeShippingNode.classList.add('is-progress-enhanced');
      }

      const initialPercent = Math.max(
        0,
        Math.min(100, Number.parseFloat(`${this.freeShippingNode.dataset.freeShippingProgressPercent || '0'}`) || 0)
      );
      this.freeShippingTargetPercent = initialPercent;
      this.freeShippingTargetReached = initialPercent >= 100;
      this.freeShippingProgressPending = initialPercent > 0;
      this.setFreeShippingProgressVisual(0, false, { animate: false });
      this.observeFreeShippingProgressSize();

      if (prefersReducedMotion()) {
        if (!this.drawerIsReadyForProgress()) {
          return;
        }
        this.setFreeShippingProgressVisual(initialPercent, this.freeShippingTargetReached, { animate: false });
        this.freeShippingHasPresented = true;
        this.freeShippingProgressPending = false;
        return;
      }

      if (this.context !== 'drawer' && !this.freeShippingNode.hidden) {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => this.flushFreeShippingProgress());
        });
      }
    }

    observeFreeShippingProgressSize() {
      if (
        !(this.freeShippingProgressRowNode instanceof HTMLElement) ||
        typeof ResizeObserver !== 'function'
      ) {
        return;
      }

      this.freeShippingResizeObserver = new ResizeObserver((entries) => {
        const entry = entries[0];
        if (
          !entry ||
          entry.contentRect.width <= 0 ||
          !this.freeShippingHasPresented ||
          !this.drawerIsReadyForProgress()
        ) {
          return;
        }
        // ResizeObserver runs after layout; update the pixel-positioned cap
        // before paint rather than leaving the previous width for one frame.
        this.setFreeShippingProgressVisual(
          this.freeShippingTargetPercent,
          this.freeShippingTargetReached,
          { animate: false }
        );
      });
      this.freeShippingResizeObserver.observe(this.freeShippingProgressRowNode);
    }

    handleDrawerStateChange(event) {
      if (this.context !== 'drawer') return;
      if (!event || !event.detail || event.detail.open !== true || event.detail.settled !== true) return;
      this.flushFreeShippingProgress();
    }

    drawerIsReadyForProgress() {
      if (this.context !== 'drawer') return true;
      const drawer = this.closest('cart-drawer-component');
      return Boolean(
        drawer &&
        drawer.isOpen &&
        !drawer.hasAttribute('data-cart-drawer-transitioning')
      );
    }

    getFreeShippingProgressGeometry() {
      const intro = this.freeShippingIntroFillNode?.parentElement;
      const milestone = this.freeShippingMilestoneFillNode?.parentElement;
      const outro = this.freeShippingOutroFillNode?.parentElement;
      const introWidth = intro instanceof HTMLElement ? intro.getBoundingClientRect().width : 0;
      const milestoneWidth = milestone instanceof HTMLElement ? milestone.getBoundingClientRect().width : 0;
      const outroWidth = outro instanceof HTMLElement ? outro.getBoundingClientRect().width : 0;
      return {
        introWidth,
        milestoneWidth,
        outroWidth,
        totalDistance: introWidth + milestoneWidth + outroWidth,
      };
    }

    renderFreeShippingProgressDistance(distance, geometry) {
      const clampedDistance = Math.max(0, Math.min(geometry.totalDistance, Number(distance) || 0));
      const introScale = geometry.introWidth > 0
        ? Math.max(0, Math.min(1, clampedDistance / geometry.introWidth))
        : 0;
      const milestoneProgress = geometry.milestoneWidth > 0
        ? Math.max(0, Math.min(1, (clampedDistance - geometry.introWidth) / geometry.milestoneWidth))
        : 0;
      const outroScale = geometry.outroWidth > 0
        ? Math.max(
            0,
            Math.min(
              1,
              (clampedDistance - geometry.introWidth - geometry.milestoneWidth) / geometry.outroWidth
            )
          )
        : 0;
      const capWidth = 6;
      const trackWidth = Math.max(0, geometry.totalDistance - capWidth);
      const trackDistance = Math.max(0, clampedDistance - capWidth);
      const trackScale = trackWidth > 0
        ? Math.min(1, trackDistance / trackWidth)
        : 0;

      if (this.freeShippingTrackFillNode instanceof HTMLElement) {
        this.freeShippingTrackFillNode.style.transform = `scaleX(${trackScale})`;
      }
      if (this.freeShippingTrackStartCapNode instanceof HTMLElement) {
        const startCapScale = Math.min(1, clampedDistance / capWidth);
        this.freeShippingTrackStartCapNode.style.opacity = clampedDistance > 0 ? '1' : '0';
        this.freeShippingTrackStartCapNode.style.transform = `scaleX(${startCapScale})`;
      }
      if (this.freeShippingTrackEndCapNode instanceof HTMLElement) {
        this.freeShippingTrackEndCapNode.style.opacity = clampedDistance > capWidth ? '1' : '0';
        this.freeShippingTrackEndCapNode.style.transform = `translateX(${trackDistance}px)`;
      }
      this.freeShippingIntroFillNode?.style.setProperty(
        '--sb-cart-free-shipping-fill',
        `${introScale * 100}%`
      );
      this.freeShippingIntroFillNode?.classList.toggle('is-connected', introScale >= 0.999);
      this.freeShippingMilestoneFillNode?.style.setProperty(
        '--sb-cart-free-shipping-milestone-fill',
        `${milestoneProgress * 100}%`
      );
      this.freeShippingMilestoneFillNode?.parentElement?.style.setProperty(
        '--sb-cart-free-shipping-milestone-fill',
        `${milestoneProgress * 100}%`
      );
      this.freeShippingMilestoneFillNode?.parentElement?.classList.toggle(
        'is-filled',
        milestoneProgress >= 0.999
      );
      this.freeShippingOutroFillNode?.style.setProperty(
        '--sb-cart-free-shipping-fill',
        `${outroScale * 100}%`
      );
      this.freeShippingNode?.classList.toggle('is-progress-filled', outroScale >= 0.999);
      this.freeShippingDisplayedDistance = clampedDistance;
    }

    setFreeShippingProgressVisual(percent, reached, { animate = true, celebrate = false } = {}) {
      if (!(this.freeShippingNode instanceof HTMLElement)) return;

      const normalizedPercent = Math.max(0, Math.min(100, Number(percent) || 0));
      const geometry = this.getFreeShippingProgressGeometry();
      if (geometry.totalDistance <= 0) {
        if (this.freeShippingAnimationFrame) {
          window.cancelAnimationFrame(this.freeShippingAnimationFrame);
          this.freeShippingAnimationFrame = 0;
        }
        if (normalizedPercent === 0) {
          if (this.freeShippingTrackFillNode instanceof HTMLElement) {
            this.freeShippingTrackFillNode.style.transform = 'scaleX(0)';
          }
          if (this.freeShippingTrackStartCapNode instanceof HTMLElement) {
            this.freeShippingTrackStartCapNode.style.opacity = '0';
            this.freeShippingTrackStartCapNode.style.transform = 'scaleX(0)';
          }
          if (this.freeShippingTrackEndCapNode instanceof HTMLElement) {
            this.freeShippingTrackEndCapNode.style.opacity = '0';
            this.freeShippingTrackEndCapNode.style.transform = 'translateX(0)';
          }
          this.freeShippingIntroFillNode?.style.setProperty('--sb-cart-free-shipping-fill', '0%');
          this.freeShippingIntroFillNode?.classList.remove('is-connected');
          this.freeShippingMilestoneFillNode?.style.setProperty(
            '--sb-cart-free-shipping-milestone-fill',
            '0%'
          );
          this.freeShippingMilestoneFillNode?.parentElement?.style.setProperty(
            '--sb-cart-free-shipping-milestone-fill',
            '0%'
          );
          this.freeShippingMilestoneFillNode?.parentElement?.classList.remove('is-filled');
          this.freeShippingOutroFillNode?.style.setProperty('--sb-cart-free-shipping-fill', '0%');
          this.freeShippingNode?.classList.remove('is-progress-filled');
          this.freeShippingDisplayedDistance = 0;
          this.freeShippingDisplayedPercent = 0;
        }
        return;
      }
      const targetDistance = reached
        ? geometry.totalDistance
        : geometry.introWidth * (normalizedPercent / 100);
      const startDistance = Math.max(0, Math.min(geometry.totalDistance, this.freeShippingDisplayedDistance));

      this.freeShippingNode.dataset.freeShippingAnimationFrom = `${this.freeShippingDisplayedPercent}`;
      this.freeShippingNode.dataset.freeShippingAnimationTo = `${normalizedPercent}`;
      this.freeShippingDisplayedPercent = normalizedPercent;

      if (this.freeShippingAnimationFrame) {
        window.cancelAnimationFrame(this.freeShippingAnimationFrame);
        this.freeShippingAnimationFrame = 0;
      }

      if (!animate || prefersReducedMotion() || Math.abs(targetDistance - startDistance) < 0.1) {
        this.renderFreeShippingProgressDistance(targetDistance, geometry);
        return;
      }

      const duration = celebrate
        ? CART_FREE_SHIPPING_CELEBRATION_DURATION
        : CART_FREE_SHIPPING_PROGRESS_DURATION;
      const startedAt = performance.now();
      const animateFrame = (now) => {
        const elapsed = Math.max(0, now - startedAt);
        const progress = Math.min(1, elapsed / duration);
        const distance = startDistance + (targetDistance - startDistance) * progress;
        this.renderFreeShippingProgressDistance(distance, geometry);
        if (progress < 1) {
          this.freeShippingAnimationFrame = window.requestAnimationFrame(animateFrame);
          return;
        }
        this.freeShippingAnimationFrame = 0;
      };
      this.freeShippingAnimationFrame = window.requestAnimationFrame(animateFrame);
    }

    queueFreeShippingProgress(percent, reached) {
      const normalizedPercent = Math.max(0, Math.min(100, Number(percent) || 0));
      const previousTarget = this.freeShippingTargetPercent;
      const newlyReached = Boolean(reached && (!this.freeShippingTargetReached || !this.freeShippingHasPresented));

      this.freeShippingTargetPercent = normalizedPercent;
      this.freeShippingTargetReached = Boolean(reached);
      this.freeShippingProgressPending =
        !this.freeShippingHasPresented ||
        Math.abs(normalizedPercent - previousTarget) > 0.01 ||
        newlyReached;
      this.freeShippingCelebratePending = this.freeShippingCelebratePending || newlyReached;

      if (prefersReducedMotion()) {
        if (!this.drawerIsReadyForProgress()) {
          return;
        }
        this.setFreeShippingProgressVisual(normalizedPercent, reached, { animate: false });
        this.freeShippingHasPresented = true;
        this.freeShippingProgressPending = false;
        this.freeShippingCelebratePending = false;
        return;
      }

      if (this.drawerIsReadyForProgress()) {
        this.flushFreeShippingProgress();
      }
    }

    resetFreeShippingProgressWhileHidden() {
      this.freeShippingTargetPercent = 0;
      this.freeShippingTargetReached = false;
      this.freeShippingProgressPending = false;
      this.freeShippingCelebratePending = false;
      this.setFreeShippingProgressVisual(0, false, { animate: false });
      this.freeShippingHasPresented = true;
    }

    flushFreeShippingProgress() {
      if (!this.freeShippingProgressPending || !(this.freeShippingNode instanceof HTMLElement)) return;
      if (this.context === 'drawer' && !this.drawerIsReadyForProgress()) return;
      if (this.freeShippingFlushScheduled) return;

      const celebrate = this.freeShippingCelebratePending && this.freeShippingTargetReached;
      if (!this.freeShippingHasPresented) {
        this.setFreeShippingProgressVisual(0, false, { animate: false });
      }

      this.freeShippingFlushScheduled = true;
      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => {
          this.freeShippingFlushScheduled = false;
          if (this.context === 'drawer' && !this.drawerIsReadyForProgress()) return;
          this.setFreeShippingProgressVisual(
            this.freeShippingTargetPercent,
            this.freeShippingTargetReached,
            { animate: true, celebrate }
          );
          this.freeShippingHasPresented = true;
          this.freeShippingProgressPending = false;
          this.freeShippingCelebratePending = false;
        });
      });
    }

    handleCartChanged(event) {
      if (!event || !event.detail || !event.detail.cart) return;
      const source = `${event.detail.source || ''}`.trim();
      const cart = event.detail.cart;
      const preserveInitialMarkup =
        !this.didInitialHydration &&
        source === 'initial' &&
        this.shouldPreserveInitialMarkup(cart);

      this.didInitialHydration = true;
      this.render(cart, { source, preserveInitialMarkup });
    }

    handleMutationStateChange(event) {
      this.cartMutationPending = event && event.detail && event.detail.pending === true;
      this.syncMutationControls();
    }

    syncMutationControls() {
      // Authoritative for the whole pending state, mirroring the native
      // themes' symmetric disable/enable contract: the global mutation lock
      // lives on the item list (pointer-events only, like Horizon's
      // cart-items-disabled), while row dimming is reserved for the item
      // actually being mutated. Renders that happen mid-mutation bake
      // disabled controls into fresh rows, so this sync must fully clear
      // that state when the mutation settles.
      if (this.itemListNode instanceof HTMLElement) {
        this.itemListNode.classList.toggle('is-mutation-pending', this.cartMutationPending);
      }
      this.querySelectorAll('[data-cart-line]').forEach((row) => {
        if (!(row instanceof HTMLElement)) return;
        const itemKey = `${row.getAttribute('data-cart-item-key') || ''}`.trim();
        const itemPending = itemKey !== '' && this.pendingItemKeys.has(itemKey);
        row.classList.toggle('is-updating', itemPending);
        row.querySelectorAll('button, input').forEach((control) => {
          if (!(control instanceof HTMLButtonElement || control instanceof HTMLInputElement)) return;
          control.disabled = this.cartMutationPending || itemPending;
        });
      });
    }

    shouldPreserveInitialMarkup(cart) {
      if (!(this.itemListNode instanceof HTMLElement)) return false;
      return this.lastRenderedItemsSignature === buildItemsSignatureFromCart(cart.items || []);
    }

    handleClick(event) {
      const target = event.target instanceof Element ? event.target : null;
      if (!target) return;

      if (target.matches('[data-cart-qty-input]') && target instanceof HTMLInputElement) {
        this.scheduleQuantityInputSelection(target);
        return;
      }

      const removeButton = target.closest('[data-cart-remove]');
      if (removeButton) {
        event.preventDefault();
        const line = this.getLineFromNode(removeButton);
        const itemKey = this.getItemKeyFromNode(removeButton);
        if (!line || !itemKey) return;
        const row = removeButton.closest('[data-cart-line]');
        this.removeLine(line, itemKey, row);
        return;
      }

      const minusButton = target.closest('[data-cart-qty-minus]');
      if (minusButton) {
        event.preventDefault();
        const line = this.getLineFromNode(minusButton);
        const itemKey = this.getItemKeyFromNode(minusButton);
        if (!line || !itemKey) return;
        const input = minusButton.closest('[data-cart-line]')?.querySelector('[data-cart-qty-input]');
        if (!(input instanceof HTMLInputElement)) return;
        const currentValue = Math.max(1, clampCount(input.value));
        if (currentValue <= 1) return;
        const nextValue = currentValue - 1;
        this.updateLine(line, itemKey, nextValue);
        return;
      }

      const plusButton = target.closest('[data-cart-qty-plus]');
      if (plusButton) {
        event.preventDefault();
        const line = this.getLineFromNode(plusButton);
        const itemKey = this.getItemKeyFromNode(plusButton);
        if (!line || !itemKey) return;
        const input = plusButton.closest('[data-cart-line]')?.querySelector('[data-cart-qty-input]');
        if (!(input instanceof HTMLInputElement)) return;
        const currentValue = clampCount(input.value);
        this.updateLine(line, itemKey, currentValue + 1);
        return;
      }
    }

    handleFocusIn(event) {
      const target = event.target;
      if (!(target instanceof HTMLInputElement)) return;
      if (!target.matches('[data-cart-qty-input]')) return;

      this.scheduleQuantityInputSelection(target);
    }

    handleChange(event) {
      const target = event.target;
      if (!(target instanceof HTMLInputElement)) return;
      if (!target.matches('[data-cart-qty-input]')) return;

      const line = this.getLineFromNode(target);
      const itemKey = this.getItemKeyFromNode(target);
      if (!line || !itemKey) return;

      const rawValue = `${target.value || ''}`.trim();
      if (/^0+$/.test(rawValue)) {
        target.value = '0';
        this.removeLine(line, itemKey, target.closest('[data-cart-line]'));
        return;
      }

      const nextValue = Math.max(1, clampCount(target.value));
      target.value = `${nextValue}`;
      this.updateLine(line, itemKey, nextValue);
    }

    scheduleQuantityInputSelection(input) {
      window.setTimeout(() => {
        if (!(input instanceof HTMLInputElement)) return;
        if (document.activeElement !== input) return;

        input.select();
        if (typeof input.setSelectionRange === 'function') {
          input.setSelectionRange(0, input.value.length);
        }
      }, 0);
    }

    handleSubmit(event) {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;

      const checkoutSubmitter = event.submitter instanceof HTMLElement
        ? event.submitter
        : form.querySelector('[data-cart-checkout-button]');
      if (checkoutSubmitter?.matches('[data-cart-checkout-button]')) {
        const discountCodes = getAppliedDiscountCodes(cachedCart || {});
        if (!discountCodes.length) return;

        // Shopify can re-evaluate a non-combinable automatic discount while
        // creating checkout and replace a manual code that was accepted in the
        // cart. Carry accepted codes explicitly so checkout preserves the
        // customer's cart choice.
        event.preventDefault();
        const checkoutUrl = new URL(cartUrl('checkout'), window.location.origin);
        checkoutUrl.searchParams.set('discount', discountCodes.join(','));
        window.location.assign(`${checkoutUrl.pathname}${checkoutUrl.search}`);
        return;
      }

    }

    getLineFromNode(node) {
      const row = node.closest('[data-cart-line]');
      if (!row) return 0;
      const line = Number.parseInt(`${row.getAttribute('data-cart-line') || ''}`, 10);
      return Number.isFinite(line) && line > 0 ? line : 0;
    }

    getItemKeyFromNode(node) {
      const row = node.closest('[data-cart-line]');
      if (!row) return '';
      return `${row.getAttribute('data-cart-item-key') || ''}`.trim();
    }

    getRowByItemKey(itemKey) {
      const normalizedItemKey = `${itemKey || ''}`.trim();
      if (!normalizedItemKey) return null;
      return Array.from(this.querySelectorAll('[data-cart-item-key]')).find(
        (row) =>
          row instanceof HTMLElement &&
          `${row.getAttribute('data-cart-item-key') || ''}`.trim() === normalizedItemKey
      ) || null;
    }

    setItemPending(itemKey, pending) {
      if (pending) {
        this.pendingItemKeys.add(itemKey);
      } else {
        this.pendingItemKeys.delete(itemKey);
      }

      const row = this.getRowByItemKey(itemKey);
      if (!(row instanceof HTMLElement)) return;

      // capture the visitor's place BEFORE disabling drops focus to body -
      // restoreMorphFocus hands it back once the update settles
      if (pending) {
        const active = document.activeElement;
        if (active instanceof HTMLElement && row.contains(active)) {
          const control = MORPH_FOCUS_CONTROLS.find((attribute) => active.hasAttribute(attribute));
          if (control) pendingMorphFocus = { key: cartRowItemKey(row), line: cartRowLine(row), control };
        }
      }

      row.classList.toggle('is-updating', pending);

      row.querySelectorAll('button, input').forEach((control) => {
        if (!(control instanceof HTMLButtonElement || control instanceof HTMLInputElement)) return;
        control.disabled = pending;
      });

      if (!pending) restoreMorphFocus(this.itemListNode);
    }

    updateLine(line, itemKey, quantity) {
      if (this.cartMutationPending || this.pendingItemKeys.has(itemKey)) return;

      this.setItemPending(itemKey, true);
      this.startPriceShimmer();

      changeLine(line, quantity, {
        source: `${this.context}-line-change`,
      }).catch(() => {
        this.stopPriceShimmer();
        this.showStatus(this.updateErrorMessage);
      }).finally(() => {
        this.stopPriceShimmer();
        this.setItemPending(itemKey, false);
      });
    }

    startPriceShimmer() {
      startTextShimmer(this.totalNode);
      startTextShimmer(this.totalSavingsAmountNode);
      startTextShimmer(this.totalSavingsTextNode);
    }

    stopPriceShimmer() {
      resetTextShimmer(this);
    }

    removeLine(line, itemKey, rowNode) {
      if (this.cartMutationPending || this.pendingItemKeys.has(itemKey)) return;

      this.setItemPending(itemKey, true);

      const row = rowNode instanceof HTMLElement ? rowNode : this.getRowByItemKey(itemKey);
      const lineRows = this.itemListNode
        ? Array.from(this.itemListNode.querySelectorAll('[data-cart-line]')).filter(
          (lineRow) => lineRow instanceof HTMLElement && !lineRow.classList.contains('is-removal-complete')
        )
        : [];
      const isLastLine = row instanceof HTMLElement && lineRows.length === 1 && lineRows[0] === row;

      if (isLastLine) {
        const previousCart = cachedCart && isCartLikePayload(cachedCart) ? cachedCart : null;
        this.render(createEmptyCartFrom(previousCart), {
          source: `${this.context}-line-remove-optimistic`,
        });

        changeLine(line, 0, {
          source: `${this.context}-line-remove`,
        })
          .catch(() => {
            if (previousCart) {
              this.render(previousCart, {
                source: `${this.context}-line-remove-restore`,
              });
            }
            this.showStatus(this.removeErrorMessage);
          })
          .finally(() => {
            this.stopPriceShimmer();
            this.setItemPending(itemKey, false);
          });

        return;
      }

      this.startPriceShimmer();

      const reduceMotion = prefersReducedMotion();
      let completeTimerId = null;
      let completeRemoval = null;
      // The morph keeps a mid-animation row in place, so the row itself must
      // leave the DOM once BOTH the animation finished and the server
      // confirmed the removal - whichever lands last - or it would linger
      // hidden and shadow selectors. On error the flag stays false and
      // clearRemovalState restores the row instead.
      let removalConfirmed = false;
      // Safari does not continuously re-clamp an overflow container's
      // scrollTop while its content shrinks: a scrolled list keeps the stale
      // offset through the whole collapse and then clamps in ONE jump when
      // layout finalizes - the "everything snaps into place at the end"
      // effect when a removal makes the cart fit again. Clamping every frame
      // folds that correction into the same gradual motion.
      // The list is normally its own scroller, but the mobile add-ons variant
      // hands scrolling to .header__cart-drawer-content - clamp whichever
      // ancestor actually scrolls or the correction lands on a no-op node.
      const removalScroller = (() => {
        let node = this.itemListNode instanceof HTMLElement ? this.itemListNode : null;
        while (node instanceof HTMLElement) {
          const { overflowY } = window.getComputedStyle(node);
          if (overflowY === 'auto' || overflowY === 'scroll') return node;
          node = node.parentElement;
        }
        return null;
      })();
      const clampRemovalScroll = () => {
        if (!removalScroller) return;
        const maxScroll = Math.max(0, removalScroller.scrollHeight - removalScroller.clientHeight);
        if (removalScroller.scrollTop > maxScroll) {
          removalScroller.scrollTop = maxScroll;
        }
      };
      const finalizeRemovalNode = () => {
        if (!removalConfirmed) return;
        if (row instanceof HTMLElement && row.classList.contains('is-removal-complete')) {
          row.remove();
          // The node is gone, so :last-child styling now covers what the
          // forward-filling animations held in place - cancel them so a
          // stale fill (e.g. a neighbor pinned at margin-bottom 0) cannot
          // outlive its reason once the list changes again.
          rowRemovalAnimations.forEach((animation) => {
            try {
              animation.cancel();
            } catch (_) {}
          });
          rowRemovalAnimations.length = 0;
          clampRemovalScroll();
        }
      };
      // The row is leaving the cart: drop its line number immediately so a
      // renumbered live row can never be shadowed by this one in
      // [data-cart-line="N"] lookups while it animates out.
      if (row instanceof HTMLElement) {
        row.removeAttribute('data-cart-line');
      }
      const rowRemovalAnimations = [];
      if (row instanceof HTMLElement && reduceMotion) {
        row.classList.add('is-removal-complete');
        clampRemovalScroll();
      } else if (row instanceof HTMLElement) {
        // Web Animations instead of a CSS animation for two reasons measured
        // in real removals: the rows are content-box, so a CSS keyframe fed
        // the border-box offsetHeight made the row grow by its padding at 0%;
        // and WebKit stamps a CSS animation's start time at style application,
        // so style hitches in the same task (fresh-render image decodes,
        // pending-state sync) made the first painted frame land mid-animation
        // - the row appeared instantly cut down. Here the height is measured
        // as border-box and enforced, and startTime is pinned to an actual
        // frame timestamp so 0% is what gets painted first in every engine.
        const measuredHeight = row.getBoundingClientRect().height;
        // The 0% keyframe must start from the row's REAL margin: the last row
        // has margin-bottom 0 (:last-child), and hardcoding 16px there shoved
        // everything below the row 16px down the instant the removal began.
        const startMargin = window.getComputedStyle(row).marginBottom || '0px';
        // Removing the last row also erases the previous row's 16px bottom
        // margin - it becomes :last-child the moment this node finally leaves
        // the DOM, which can be long after the collapse finishes (the node
        // waits for server confirmation while display:none). Close that
        // margin with the same motion, or it lingers as a gap and then
        // vanishes in one jump. Skip mid-removal siblings: their own
        // animations already own their margins.
        let neighborRow = null;
        if (!row.nextElementSibling) {
          let candidate = row.previousElementSibling;
          while (
            candidate instanceof HTMLElement
            && (candidate.classList.contains('is-removing') || candidate.classList.contains('is-removal-complete'))
          ) {
            candidate = candidate.previousElementSibling;
          }
          if (candidate instanceof HTMLElement) neighborRow = candidate;
        }
        row.style.boxSizing = 'border-box';
        completeRemoval = () => {
          if (completeTimerId) {
            window.clearTimeout(completeTimerId);
            completeTimerId = null;
          }
          completeRemoval = null;
          row.classList.add('is-removal-complete');
          finalizeRemovalNode();
        };
        row.classList.add('is-removing');
        const collapse = row.animate(
          [
            { height: `${measuredHeight}px`, marginBottom: startMargin, paddingTop: '12px', paddingBottom: '12px' },
            { paddingTop: '12px', offset: 0.6 },
            { height: '0px', marginBottom: '0px', paddingTop: '0px', paddingBottom: '0px' },
          ],
          { duration: CART_ROW_REMOVE_ANIMATION_DURATION, easing: 'cubic-bezier(0.3, 0, 0, 1)', fill: 'forwards' }
        );
        const fade = row.animate(
          [{ opacity: 1 }, { opacity: 0 }],
          { duration: CART_ROW_REMOVE_FADE_DURATION, easing: 'ease-out', fill: 'forwards' }
        );
        collapse.pause();
        fade.pause();
        rowRemovalAnimations.push(collapse, fade);
        if (neighborRow) {
          const neighborMargin = neighborRow.animate(
            [
              { marginBottom: window.getComputedStyle(neighborRow).marginBottom || '16px' },
              { marginBottom: '0px' },
            ],
            { duration: CART_ROW_REMOVE_ANIMATION_DURATION, easing: 'cubic-bezier(0.3, 0, 0, 1)', fill: 'forwards' }
          );
          neighborMargin.pause();
          rowRemovalAnimations.push(neighborMargin);
        }
        // Double rAF: the first frame after the click absorbs the one-off
        // setup cost (overflow clip, style recalc, and in Safari the deferred
        // image decode storm that follows the drawer auto-opening on add)
        // while the row sits paused at 0%. Only when a frame has actually
        // been produced do we anchor the clock, so the first ANIMATED frame
        // is always the beginning of the motion. The timeout is a mandatory
        // backstop: a paused animation invalidates nothing, so in renderers
        // that only produce frames on demand the rAF alone can simply never
        // fire and the removal would hang at 0%.
        let removalStartArmed = true;
        const startRemovalAnimations = () => {
          if (!removalStartArmed || !completeRemoval) return;
          removalStartArmed = false;
          const startTime = document.timeline.currentTime;
          rowRemovalAnimations.forEach((animation) => {
            animation.startTime = startTime;
          });
          const clampTick = () => {
            clampRemovalScroll();
            if (collapse.playState === 'running') {
              window.requestAnimationFrame(clampTick);
            } else {
              clampRemovalScroll();
            }
          };
          window.requestAnimationFrame(clampTick);
        };
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(startRemovalAnimations);
        });
        window.setTimeout(startRemovalAnimations, 64);
        collapse.finished
          .then(() => {
            if (completeRemoval) completeRemoval();
          })
          .catch(() => {});
        completeTimerId = window.setTimeout(() => {
          if (completeRemoval) completeRemoval();
        }, CART_ROW_REMOVE_ANIMATION_DURATION + 400);
      }

      const clearRemovalState = () => {
        if (!(row instanceof HTMLElement)) return;
        completeRemoval = null;
        if (completeTimerId) {
          window.clearTimeout(completeTimerId);
          completeTimerId = null;
        }
        rowRemovalAnimations.forEach((animation) => {
          try {
            animation.cancel();
          } catch (_) {}
        });
        rowRemovalAnimations.length = 0;
        row.classList.remove('is-removing');
        row.classList.remove('is-removal-complete');
        row.style.removeProperty('box-sizing');
        if (cachedCart) {
          // Restore functional row identity from the latest reliable cart,
          // even when recovery failed. Force the keyed morph to run because
          // the item signature can be unchanged despite the missing line.
          this.lastRenderedItemsSignature = '';
          this.render(cachedCart, {
            source: `${this.context}-line-remove-restore`,
          });
        }
      };

      changeLine(line, 0, {
        source: `${this.context}-line-remove`,
        delay: reduceMotion ? 0 : CART_ROW_REMOVE_DELAY,
      })
        .then(() => {
          removalConfirmed = true;
          // From here the row is pure exit animation for an item the server
          // already dropped. Register the finalizer that lets the next render
          // purge the row should the animation stall instead of finishing;
          // the normal finish path detaches the row and the entry dies with
          // the node.
          if (row instanceof HTMLElement && !row.classList.contains('is-removal-complete')) {
            confirmedRemovalFinalizers.set(row, () => {
              if (completeRemoval) completeRemoval();
            });
          }
          finalizeRemovalNode();
        })
        .catch(() => {
          this.stopPriceShimmer();
          clearRemovalState();
          this.showStatus(this.removeErrorMessage);
        })
        .finally(() => {
          this.stopPriceShimmer();
          this.setItemPending(itemKey, false);
        });

    }

    render(cart, { source = '', preserveInitialMarkup = false } = {}) {
      const itemCount = clampCount(cart && cart.item_count ? cart.item_count : 0);
      const hasServerRows =
        this.itemListNode instanceof HTMLElement &&
        this.itemListNode.querySelector('[data-cart-line]') instanceof HTMLElement;
      const preserveNonEmptyServerState =
        preserveInitialMarkup &&
        hasServerRows;
      const isEmpty = preserveNonEmptyServerState ? false : itemCount === 0;
      const cartCurrency = `${cart && cart.currency ? cart.currency : ''}`.trim().toUpperCase();
      const currency = (this.displayCurrency || cartCurrency || '').trim().toUpperCase();
      if (!this.displayCurrency && cartCurrency) {
        this.displayCurrency = cartCurrency;
      }
      const wasEmpty = this.classList.contains('is-empty');
      const shouldAnimateToEmpty = this.hasRenderedCartState && !wasEmpty && isEmpty;

      const applyRenderState = () => {
        this.classList.toggle('is-empty', isEmpty);

        if (this.statusNode) {
          this.statusNode.hidden = true;
          (this.statusTextNode || this.statusNode).textContent = '';
        }

        if (this.pageHeaderNode) {
          this.pageHeaderNode.hidden = isEmpty;
        }

        this.emptyMessageNodes.forEach((node) => {
          node.hidden = !isEmpty;
        });

        this.filledMessageNodes.forEach((node) => {
          node.hidden = isEmpty;
        });

        if (this.emptyNode) {
          this.emptyNode.hidden = !isEmpty;
        }

        if (this.itemListNode) {
          this.itemListNode.hidden = isEmpty;
        }

        if (this.summaryNode) {
          this.summaryNode.hidden = isEmpty;
        }

        if (this.summaryDividerNode) {
          this.summaryDividerNode.hidden = isEmpty;
        }

        this.checkoutButtons.forEach((button) => {
          button.toggleAttribute('aria-disabled', isEmpty);
          if (button instanceof HTMLButtonElement || button instanceof HTMLInputElement) {
            button.disabled = isEmpty;
          }
        });

        if (this.totalNode) {
          const totalText = formatMoney(
            cart && cart.total_price ? cart.total_price : 0,
            currency
          );
          this.totalNode.textContent = totalText;
          setShimmerValue(this.totalNode, totalText);
        }

        this.renderFreeShipping(cart || {}, currency, isEmpty);
        this.renderDiscounts(cart || {}, currency);
        this.renderItems(cart || {}, currency, { source, preserveInitialMarkup });

        const drawer = this.closest('cart-drawer-component');
        if (drawer && typeof drawer.updateStickyState === 'function') {
          drawer.updateStickyState();
        }

        this.hasRenderedCartState = true;
      };

      const animateEmptyState = () => {
        if (!(this.emptyNode instanceof HTMLElement) || prefersReducedMotion()) return;
        this.emptyNode.classList.remove('is-entering');
        void this.emptyNode.offsetWidth;
        this.emptyNode.classList.add('is-entering');
        const finish = (event) => {
          if (event.target !== this.emptyNode) return;
          this.emptyNode.removeEventListener('animationend', finish);
          this.emptyNode.classList.remove('is-entering');
        };
        this.emptyNode.addEventListener('animationend', finish);
      };

      if (shouldAnimateToEmpty) {
        applyRenderState();
        animateEmptyState();
        return;
      }

      applyRenderState();
    }

    renderDiscounts(cart, currency = '') {
      const totalSavings = getCartTotalSavingsSummary(cart || {}, currency, this.totalSavingsTemplate);

      if (this.autoDiscountRowNode) {
        this.autoDiscountRowNode.dataset.cartHasTotalSavings = totalSavings.hasSavings ? 'true' : 'false';
      }

      if (this.totalSavingsTextNode) {
        this.totalSavingsTextNode.textContent = totalSavings.text;
        setShimmerValue(this.totalSavingsTextNode, totalSavings.text);
      }

      if (this.totalSavingsAmountNode) {
        this.totalSavingsAmountNode.textContent = totalSavings.amountText;
        setShimmerValue(this.totalSavingsAmountNode, totalSavings.amountText);
      }

    }

    renderItems(cart, currency, { source = '', preserveInitialMarkup = false } = {}) {
      if (!this.itemListNode) return;

      // Fresh cart data supersedes any removal the server already confirmed:
      // finalize stalled removal rows BEFORE the unchanged-signature early
      // returns below, or a zombie row would survive every render whose item
      // list matches the last rendered one.
      purgeConfirmedRemovalRows(this.itemListNode);

      const items = Array.isArray(cart.items) ? cart.items : [];
      const existingPrimaryImageByKey = new Map();
      const existingPrimaryImageByVariantId = new Map();
      const existingHoverImageByKey = new Map();
      const existingHoverImageByVariantId = new Map();
      this.itemListNode.querySelectorAll('[data-cart-item-key]').forEach((row) => {
        if (!(row instanceof HTMLElement)) return;
        const key = `${row.getAttribute('data-cart-item-key') || ''}`.trim();
        const primaryImage = row.querySelector('.sb-cart-line__image--primary:not(.sb-cart-line__image--placeholder)');
        const primaryImageUrl = primaryImage instanceof HTMLImageElement
          && !primaryImage.hasAttribute('data-sb-cart-deferred-image')
          ? getNodeMediaSource(primaryImage)
          : '';
        const hoverImage = `${row.getAttribute('data-cart-hover-image') || ''}`.trim();
        if (!key) return;
        if (primaryImageUrl) existingPrimaryImageByKey.set(key, {
          src: primaryImageUrl,
          srcset: primaryImage.getAttribute('srcset') || '',
        });
        if (hoverImage) existingHoverImageByKey.set(key, hoverImage);
      });
      this.itemListNode.querySelectorAll('[data-cart-line]').forEach((row) => {
        if (!(row instanceof HTMLElement)) return;
        const variantId = Number.parseInt(`${row.getAttribute('data-cart-variant-id') || ''}`, 10);
        const primaryImage = row.querySelector('.sb-cart-line__image--primary:not(.sb-cart-line__image--placeholder)');
        const primaryImageUrl = primaryImage instanceof HTMLImageElement
          && !primaryImage.hasAttribute('data-sb-cart-deferred-image')
          ? getNodeMediaSource(primaryImage)
          : '';
        const hoverImage = `${row.getAttribute('data-cart-hover-image') || ''}`.trim();
        if (!Number.isFinite(variantId) || variantId <= 0) return;
        const variantIdKey = `${variantId}`;
        if (primaryImageUrl) {
          existingPrimaryImageByVariantId.set(variantIdKey, primaryImageUrl);
          pendingPrimaryImageByVariantId.set(variantIdKey, primaryImageUrl);
        }
        if (hoverImage) {
          existingHoverImageByVariantId.set(variantIdKey, hoverImage);
          pendingHoverImageByVariantId.set(variantIdKey, hoverImage);
        }
      });
      const nextItemsSignature = buildItemsSignatureFromCart(items);
      const hasCompleteServerLinePriceMarkup =
        preserveInitialMarkup
        && items.length > 0
        && items.every((_, index) => {
          const row = this.itemListNode.querySelector(`[data-cart-line="${index + 1}"]`);
          return row instanceof HTMLElement
            && row.querySelector('.sb-cart-line__price-state') instanceof HTMLElement;
        });

      const syncLineItemPrices = () => {
        items.forEach((item, index) => {
          const line = index + 1;
          const row = this.itemListNode.querySelector(`[data-cart-line="${line}"]`);
          if (!(row instanceof HTMLElement)) return;

          const originalLinePriceCents = Number.isFinite(Number(item.original_line_price))
            ? Number(item.original_line_price)
            : 0;
          const combinedFinalLinePriceCents = getItemCombinedFinalLinePriceCents(item);
          const priceGroup = row.querySelector('.sb-cart-line__price-group');
          if (!(priceGroup instanceof HTMLElement)) return;

          priceGroup.innerHTML = renderCartLinePriceStates({
            originalLinePriceCents,
            combinedFinalLinePriceCents,
            currency,
          });
        });
      };

      if (preserveInitialMarkup && `${this.lastRenderedItemsSignature || ''}`.trim() !== '') {
        if (!hasCompleteServerLinePriceMarkup) {
          syncLineItemPrices();
        }
        return;
      }

      // Prevent unnecessary full list re-renders (image flash) when only price state changes.
      // For discount changes we patch line-item prices in place.
      if (nextItemsSignature === this.lastRenderedItemsSignature) {
        if (source === 'drawer-open') {
          return;
        }
        syncLineItemPrices();
        return;
      }

      const fragment = document.createDocumentFragment();

      items.forEach((item, index) => {
        const line = index + 1;
        const itemKey = `${item && item.key ? item.key : ''}`.trim();
        const variantId = Number.parseInt(`${item && item.variant_id ? item.variant_id : ''}`, 10);
        const variantIdKey = Number.isFinite(variantId) && variantId > 0 ? `${variantId}` : '';
        const hoverImageUrl = `${(variantIdKey ? serverHoverImageByVariantId.get(variantIdKey) : '')
          || existingHoverImageByKey.get(itemKey)
          || (variantIdKey ? existingHoverImageByVariantId.get(variantIdKey) : '')
          || (variantIdKey ? pendingHoverImageByVariantId.get(variantIdKey) : '')
          || ''}`.trim();
        const lineItem = document.createElement('li');
        lineItem.className = 'sb-cart-line';
        lineItem.setAttribute('data-cart-line', `${line}`);
        if (itemKey) {
          lineItem.setAttribute('data-cart-item-key', itemKey);
        }
        if (Number.isFinite(variantId) && variantId > 0) {
          lineItem.setAttribute('data-cart-variant-id', `${variantId}`);
        }
        const productId = Number.parseInt(`${item && item.product_id ? item.product_id : ''}`, 10);
        if (Number.isFinite(productId) && productId > 0) {
          lineItem.setAttribute('data-cart-product-id', `${productId}`);
        }
        if (hoverImageUrl) {
          lineItem.setAttribute('data-cart-hover-image', hoverImageUrl);
          if (variantIdKey) {
            pendingHoverImageByVariantId.set(variantIdKey, hoverImageUrl);
          }
        }

        const title = escapeHtml(item.product_title || item.title || this.productNameLabel);
        const productUrl = escapeHtml(item.url || '#');
        const variantTitle = escapeHtml(getItemVariantTitle(item));
        const responsiveImage = item.sb_image || existingPrimaryImageByKey.get(itemKey);
        const rawImageUrl = `${responsiveImage?.src
          || (variantIdKey ? existingPrimaryImageByVariantId.get(variantIdKey) : '')
          || (variantIdKey ? pendingPrimaryImageByVariantId.get(variantIdKey) : '')
          || getItemImageUrl(item)
          || ''}`.trim();
        if (rawImageUrl && variantIdKey) {
          pendingPrimaryImageByVariantId.set(variantIdKey, rawImageUrl);
        }
        const hasRealImage = Boolean(`${rawImageUrl || ''}`.trim());
        const imageUrl = escapeHtml(rawImageUrl || this.placeholderImage);
        const responsiveImageAttributes = responsiveImage?.srcset
          ? `srcset="${escapeHtml(responsiveImage.srcset)}" sizes="64px"` : '';
        const escapedHoverImageUrl = hoverImageUrl ? escapeHtml(hoverImageUrl) : '';
        const mediaClass = escapedHoverImageUrl
          ? 'sb-cart-line__media sb-cart-line__media--has-hover'
          : 'sb-cart-line__media';
        const primaryImageClass = hasRealImage
          ? 'sb-cart-line__image sb-cart-line__image--primary'
          : 'sb-cart-line__image sb-cart-line__image--primary sb-cart-line__image--placeholder';
        const quantity = clampCount(item.quantity || 0);
        const effectiveQuantity = Math.max(1, quantity);
        const originalLinePriceCents = Number.isFinite(Number(item.original_line_price))
          ? Number(item.original_line_price)
          : 0;
        const combinedFinalLinePriceCents = getItemCombinedFinalLinePriceCents(item);
        const linePriceStates = renderCartLinePriceStates({
          originalLinePriceCents,
          combinedFinalLinePriceCents,
          currency,
        });
        const decreaseButton = effectiveQuantity <= 1
          ? `
                <button
                  type="button"
                  class="sb-cart-quantity__button sb-cart-quantity__button--remove"
                  data-cart-remove
                  aria-label="${escapeHtml(this.removeItemLabel)}"
                >
                  <span class="sb-cart-quantity__icon sb-cart-quantity__icon--remove" aria-hidden="true">${CART_ICON_REMOVE_SVG}</span>
                </button>
              `
          : `
                <button
                  type="button"
                  class="sb-cart-quantity__button"
                  data-cart-qty-minus
                  aria-label="${escapeHtml(this.decreaseQuantityLabel)}"
                >
                  <span class="sb-cart-quantity__icon sb-cart-quantity__icon--minus" aria-hidden="true">${CART_ICON_MINUS_SVG}</span>
                </button>
              `;

        lineItem.innerHTML = `
          <a class="${mediaClass}" href="${productUrl}" data-image-frame>
            <img class="${primaryImageClass}" src="${imageUrl}" ${responsiveImageAttributes} alt="${title}" loading="eager" width="128" height="128">
            ${
              escapedHoverImageUrl
                ? `<img class="sb-cart-line__image sb-cart-line__image--hover" src="${escapedHoverImageUrl}" alt="" loading="eager" width="128" height="128" aria-hidden="true">`
                : ''
            }
          </a>
          <div class="sb-cart-line__content">
            <div class="sb-cart-line__meta">
              <a class="sb-cart-line__title font-caption weight-bold" href="${productUrl}">${title}</a>
              ${
                variantTitle
                  ? `<p class="sb-cart-line__variant font-caption weight-regular">${variantTitle}</p>`
                  : ''
              }
              </div>
              <div class="sb-cart-line__controls">
                <div class="sb-cart-line__price-group">
                  ${linePriceStates}
                </div>
              <div class="sb-cart-quantity" role="group" aria-label="${escapeHtml(this.quantityLabel)}">
                ${decreaseButton}
                <input
                  class="sb-cart-quantity__input font-form-input weight-bold"
                  data-cart-qty-input
                  type="text"
                  pattern="[0-9]*"
                  inputmode="numeric"
                  autocomplete="off"
                  value="${effectiveQuantity}"
                  aria-label="${escapeHtml(this.quantityLabel)}"
                >
                <button type="button" class="sb-cart-quantity__button" data-cart-qty-plus aria-label="${escapeHtml(this.increaseQuantityLabel)}">
                  <span class="sb-cart-quantity__icon sb-cart-quantity__icon--plus" aria-hidden="true">${CART_ICON_PLUS_SVG}</span>
                </button>
              </div>
            </div>
          </div>
        `;

        const itemPending = this.pendingItemKeys.has(itemKey);
        if (itemPending) {
          lineItem.classList.add('is-updating');
        }
        if (this.cartMutationPending || itemPending) {
          lineItem.querySelectorAll('button, input').forEach((control) => {
            if (
              control instanceof HTMLButtonElement ||
              control instanceof HTMLInputElement
            ) {
              control.disabled = true;
            }
          });
        }

        fragment.appendChild(lineItem);
      });

      morphCartLineList(this.itemListNode, fragment);
      prepareCartHoverImages(this.itemListNode);
      this.lastRenderedItemsSignature = nextItemsSignature;
    }

    renderFreeShipping(cart, currency, isEmpty) {
      if (!this.freeShippingNode) return;
      if (isEmpty) {
        this.resetFreeShippingProgressWhileHidden();
        this.freeShippingNode.hidden = true;
        return;
      }

      const isAvailable = `${this.freeShippingNode.dataset.freeShippingAvailable || ''}`.toLowerCase() === 'true';
      const thresholdCents = Number.parseInt(`${this.freeShippingNode.dataset.freeShippingThresholdCents || '0'}`, 10);
      const subtotalCents = Number(cart && Number.isFinite(Number(cart.total_price)) ? cart.total_price : 0);
      const shouldShow = isAvailable && Number.isFinite(thresholdCents) && thresholdCents > 0;

      if (!shouldShow) {
        this.resetFreeShippingProgressWhileHidden();
        this.freeShippingNode.hidden = true;
        return;
      }

      const remainingCents = Math.max(0, thresholdCents - subtotalCents);
      const reached = remainingCents <= 0;
      const progressPercent = Math.max(0, Math.min(100, (subtotalCents / thresholdCents) * 100));
      this.freeShippingNode.dataset.freeShippingProgressPercent = `${progressPercent}`;

      if (this.freeShippingMessageNode) {
        const unlockedTemplate = `${this.freeShippingNode.dataset.freeShippingUnlockedTemplate || ''}`.trim();
        const remainingTemplate = `${this.freeShippingNode.dataset.freeShippingRemainingTemplate || ''}`.trim();
        if (reached) {
          if (unlockedTemplate) {
            this.freeShippingMessageNode.innerHTML = unlockedTemplate;
          }
        } else if (remainingTemplate) {
          const formattedRemaining = escapeHtml(formatMoney(remainingCents, currency));
          this.freeShippingMessageNode.innerHTML = remainingTemplate.replace(/__AMOUNT__/g, formattedRemaining);
        }
      }

      this.freeShippingNode.classList.toggle('is-reached', reached);
      this.freeShippingNode.hidden = false;
      this.queueFreeShippingProgress(progressPercent, reached);
    }

    showStatus(message) {
      if (!this.statusNode) return;
      const text = `${message || ''}`.trim();
      (this.statusTextNode || this.statusNode).textContent = text;
      this.statusNode.hidden = text === '';
    }

  }

  if (!customElements.get('cart-drawer-component')) {
    customElements.define('cart-drawer-component', CartDrawerComponent);
  }

  if (!customElements.get('cart-items-component')) {
    customElements.define('cart-items-component', CartItemsComponent);
  }

  window.SBCart = {
    ...(window.SBCart || {}),
    fetch: fetchCart,
    refresh: refreshCart,
    add: addToCart,
    setNextAddSourceElement: (element) => {
      if (element instanceof Element) nextAddSourceElement = element;
    },
    consumeNextAddSourceElement: () => {
      const element = nextAddSourceElement;
      nextAddSourceElement = null;
      return element instanceof Element ? element : null;
    },
    animateButtonSuccess,
    animateFlyToCart,
    clear: clearCart,
    changeLine,
    updateAttributes,
    applyDiscount,
    hasAcceptedDiscountCode: cartHasAcceptedDiscountCode,
    getCart: () => cachedCart,
    open: () => {
      if (isOnCartPage) return;
      const drawer = document.querySelector('cart-drawer-component');
      if (drawer && typeof drawer.open === 'function') {
        drawer.open();
      }
    },
    close: () => {
      const drawer = document.querySelector('cart-drawer-component');
      if (drawer && typeof drawer.close === 'function') {
        drawer.close();
      }
    },
  };
  document.dispatchEvent(new CustomEvent('sb:cart-system-ready'));

  document.addEventListener('cart:update', (event) => {
    const detail = event && event.detail ? event.detail : null;
    if (detail && detail.sourceId === 'sb-cart-system') return;

    if (detail && detail.resource && isCartLikePayload(detail.resource)) {
      const source = detail.data?.variantId && Number(detail.data.itemCount) > 0
        ? 'add' : (detail.data?.source || 'external');
      updateCartAndDispatch(detail.resource, source, {
        animateBadge: false,
        itemCount: detail.data && Number.isFinite(Number(detail.data.itemCount)) ? Number(detail.data.itemCount) : 0,
      });
      const drawer = document.querySelector('cart-drawer-component');
      if (!isOnCartPage && drawer && typeof drawer.open === 'function' && source !== 'header-cart') {
        drawer.open();
      }
      return;
    }

    refreshCart({ source: 'external', animateBadge: false }).catch(() => {
      // no-op
    });
  });

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (event.defaultPrevented) return;

    const action = `${form.getAttribute('action') || ''}`.trim();
    if (!action) return;
    if (!/\/cart\/add(?:\.js)?(?:\?|$)/.test(action)) return;
    if (form.hasAttribute('data-no-ajax-cart-add')) return;

    event.preventDefault();

    const formData = new FormData(form);
    const variantId = `${formData.get('id') || ''}`.trim();
    const quantityRaw = `${formData.get('quantity') || '1'}`.trim();
    const quantity = clampCount(quantityRaw || 1) || 1;

    if (!variantId) return;

    const submitter = event.submitter instanceof HTMLElement ? event.submitter : null;
    if (submitter instanceof HTMLButtonElement || submitter instanceof HTMLInputElement) {
      if (submitter.dataset.cartSubmitPending === 'true') return;
      submitter.dataset.cartSubmitPending = 'true';
      submitter.disabled = true;
    }

    const overrideSourceElement =
      window.SBCart && typeof window.SBCart.consumeNextAddSourceElement === 'function'
        ? window.SBCart.consumeNextAddSourceElement()
        : null;

    addToCart(variantId, {
      quantity,
      sourceElement: overrideSourceElement || submitter || form,
    })
      .catch(() => {
        // no-op
      })
      .finally(() => {
        if (submitter instanceof HTMLButtonElement || submitter instanceof HTMLInputElement) {
          delete submitter.dataset.cartSubmitPending;
          submitter.disabled = submitter.dataset.variantAvailable === 'false';
        }
      });
  });

  refreshCart({ source: 'initial', animateBadge: false }).catch(() => {
    // no-op
  });
})();
